export const chainMetadata = {
    "abstracttestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-explorer-verify.testnet.abs.xyz/contract_verification",
                "family": "etherscan",
                "name": "Abstract Block Explorer",
                "url": "https://explorer.testnet.abs.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 11124,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Abstract Testnet",
        "domainId": 11124,
        "isTestnet": true,
        "name": "abstracttestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.testnet.abs.xyz"
            }
        ],
        "technicalStack": "zksync"
    },
    "alephzeroevmmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm-explorer.alephzero.org/api",
                "family": "blockscout",
                "name": "Aleph Zero Explorer",
                "url": "https://evm-explorer.alephzero.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 41455,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Aleph Zero EVM",
        "displayNameShort": "Aleph Zero EVM",
        "domainId": 1000041455,
        "gasCurrencyCoinGeckoId": "aleph-zero",
        "index": {
            "from": 4243354
        },
        "name": "alephzeroevmmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "AZERO",
            "symbol": "AZERO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.alephzero.raas.gelato.cloud"
            },
            {
                "http": "https://alephzero.drpc.org"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "alephzeroevmtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm-explorer-testnet.alephzero.org/api",
                "family": "blockscout",
                "name": "Aleph Zero EVM Testnet Explorer",
                "url": "https://evm-explorer-testnet.alephzero.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 2039,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Aleph Zero EVM Testnet",
        "domainId": 2039,
        "index": {
            "from": 1380870
        },
        "isTestnet": true,
        "name": "alephzeroevmtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Testnet AZERO",
            "symbol": "TZERO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.alephzero-testnet.gelato.digital"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "alfajores": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.celo.org/alfajores/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://explorer.celo.org/alfajores"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 5,
            "reorgPeriod": 0
        },
        "chainId": 44787,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Alfajores",
        "domainId": 44787,
        "gasCurrencyCoinGeckoId": "celo",
        "isTestnet": true,
        "name": "alfajores",
        "nativeToken": {
            "decimals": 18,
            "name": "CELO",
            "symbol": "CELO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://alfajores-forno.celo-testnet.org"
            }
        ]
    },
    "ancient8": {
        "blockExplorers": [
            {
                "apiUrl": "https://scan.ancient8.gg/api",
                "family": "blockscout",
                "name": "Ancient8 Explorer",
                "url": "https://scan.ancient8.gg"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 888888888,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Ancient8",
        "domainId": 888888888,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe.ancient8.gg/txs/",
        "isTestnet": false,
        "name": "ancient8",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ancient8.gg"
            }
        ],
        "technicalStack": "opstack"
    },
    "apechain": {
        "blockExplorers": [
            {
                "apiUrl": "https://apechain.calderaexplorer.xyz/api",
                "family": "blockscout",
                "name": "ApeChain Explorer",
                "url": "https://apechain.calderaexplorer.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.2,
            "reorgPeriod": 5
        },
        "chainId": 33139,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "ApeChain",
        "domainId": 33139,
        "gasCurrencyCoinGeckoId": "apecoin",
        "index": {
            "from": 1759561
        },
        "name": "apechain",
        "nativeToken": {
            "decimals": 18,
            "name": "ApeCoin",
            "symbol": "APE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.apechain.com/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "arbitrum": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.arbiscan.io/api",
                "family": "etherscan",
                "name": "Arbiscan",
                "url": "https://arbiscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 42161,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Arbitrum",
        "domainId": 42161,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-arbitrum.safe.global/",
        "index": {
            "from": 143649797
        },
        "name": "arbitrum",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://arbitrum.llamarpc.com"
            },
            {
                "http": "https://rpc.ankr.com/arbitrum"
            },
            {
                "http": "https://arb1.arbitrum.io/rpc"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "arbitrumnova": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-nova.arbiscan.io/api",
                "family": "etherscan",
                "name": "Arbiscan Nova",
                "url": "https://nova.arbiscan.io/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 42170,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Arbitrum Nova",
        "domainId": 42170,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 78794208
        },
        "name": "arbitrumnova",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://nova.arbitrum.io/rpc"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "arbitrumsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.arbiscan.io/api",
                "family": "etherscan",
                "name": "Arbiscan",
                "url": "https://sepolia.arbiscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 0
        },
        "chainId": 421614,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Arbitrum Sepolia",
        "domainId": 421614,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 49690504
        },
        "isTestnet": true,
        "name": "arbitrumsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://arbitrum-sepolia.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://sepolia-rollup.arbitrum.io/rpc"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "arcadiatestnet2": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.khalani.network/api",
                "family": "blockscout",
                "name": "Arcadia Testnet Explorer",
                "url": "https://explorer.khalani.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 1098411886,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Arcadia Testnet v2",
        "domainId": 1098411886,
        "isTestnet": true,
        "name": "arcadiatestnet2",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.khalani.network"
            }
        ]
    },
    "artelatestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://betanet-scan.artela.network/api",
                "family": "blockscout",
                "name": "Artela Testnet Explorer",
                "url": "https://betanet-scan.artela.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 11822,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Artela Testnet",
        "domainId": 11822,
        "isTestnet": true,
        "name": "artelatestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Testnet Artela",
            "symbol": "ART"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://betanet-rpc1.artela.network"
            },
            {
                "http": "https://betanet-rpc2.artela.network"
            }
        ]
    },
    "arthera": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.arthera.net/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://explorer.arthera.net"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 10242,
        "deployer": {
            "name": "Arthera",
            "url": "https://www.arthera.net"
        },
        "displayName": "Arthera",
        "domainId": 10242,
        "name": "arthera",
        "nativeToken": {
            "decimals": 18,
            "name": "Arthera",
            "symbol": "AA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.arthera.net",
                "pagination": {
                    "maxBlockRange": 10000
                }
            }
        ]
    },
    "artheratestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-test.arthera.net/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://explorer-test.arthera.net"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 10243,
        "deployer": {
            "name": "Arthera",
            "url": "https://www.arthera.net"
        },
        "displayName": "Arthera Testnet",
        "domainId": 10243,
        "isTestnet": true,
        "name": "artheratestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Arthera",
            "symbol": "AA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-test.arthera.net",
                "pagination": {
                    "maxBlockRange": 10000
                }
            }
        ]
    },
    "astar": {
        "blockExplorers": [
            {
                "apiUrl": "https://astar.blockscout.com/api",
                "family": "blockscout",
                "name": "Astar Explorer",
                "url": "https://astar.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 13,
            "reorgPeriod": "finalized"
        },
        "chainId": 592,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Astar",
        "domainId": 592,
        "gasCurrencyCoinGeckoId": "astar",
        "name": "astar",
        "nativeToken": {
            "decimals": 18,
            "name": "Astar",
            "symbol": "ASTR"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm.astar.network"
            }
        ],
        "technicalStack": "polkadotsubstrate"
    },
    "astarzkevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://astar-zkevm.explorer.startale.com/api",
                "family": "blockscout",
                "name": "Astar zkEVM Explorer",
                "url": "https://astar-zkevm.explorer.startale.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 3776,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Astar zkEVM",
        "domainId": 3776,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "astarzkevm",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.startale.com/astar-zkevm"
            },
            {
                "http": "https://astar-zkevm-rpc.dwellir.com"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "avalanche": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/43114/etherscan/api",
                "family": "routescan",
                "name": "SnowTrace",
                "url": "https://snowtrace.io"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": 3
        },
        "chainId": 43114,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Avalanche",
        "domainId": 43114,
        "gasCurrencyCoinGeckoId": "avalanche-2",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-avalanche.safe.global/",
        "name": "avalanche",
        "nativeToken": {
            "decimals": 18,
            "name": "Avalanche",
            "symbol": "AVAX"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ankr.com/avalanche"
            },
            {
                "http": "https://api.avax.network/ext/bc/C/rpc",
                "pagination": {
                    "maxBlockRange": 100000,
                    "minBlockNumber": 6765067
                }
            }
        ],
        "technicalStack": "other"
    },
    "b3": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.b3.fun/api",
                "family": "blockscout",
                "name": "B3 Explorer",
                "url": "https://explorer.b3.fun"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 5
        },
        "chainId": 8333,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "B3",
        "domainId": 8333,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "b3",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet-rpc.b3.fun"
            }
        ],
        "technicalStack": "opstack"
    },
    "base": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.basescan.org/api",
                "family": "etherscan",
                "name": "BaseScan",
                "url": "https://basescan.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 10
        },
        "chainId": 8453,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Base",
        "domainId": 8453,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-base.safe.global/",
        "name": "base",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://base.publicnode.com/"
            },
            {
                "http": "https://mainnet.base.org"
            },
            {
                "http": "https://base.blockpi.network/v1/rpc/public"
            }
        ],
        "technicalStack": "opstack"
    },
    "basesepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.basescan.org/api",
                "family": "etherscan",
                "name": "BaseScan",
                "url": "https://sepolia.basescan.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 84532,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Base Sepolia",
        "domainId": 84532,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "basesepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.base.org"
            },
            {
                "http": "https://base-sepolia-rpc.publicnode.com"
            }
        ]
    },
    "berabartio": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/testnet/evm/80084/etherscan/api/",
                "family": "routescan",
                "name": "Bartio Testnet Explorer",
                "url": "https://bartio.beratrail.io/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 1
        },
        "chainId": 80084,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Berachain bArtio",
        "domainId": 80084,
        "gasCurrencyCoinGeckoId": "berachain",
        "isTestnet": true,
        "name": "berabartio",
        "nativeToken": {
            "decimals": 18,
            "name": "BERA",
            "symbol": "BERA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://bartio.rpc.berachain.com/"
            },
            {
                "http": "https://bartio.drpc.org"
            },
            {
                "http": "https://bera-testnet.nodeinfra.com"
            }
        ]
    },
    "bitlayer": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.btrscan.com/scan/api",
                "family": "other",
                "name": "Bitlayer Explorer",
                "url": "https://www.btrscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 20
        },
        "chainId": 200901,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Bitlayer",
        "domainId": 200901,
        "gasCurrencyCoinGeckoId": "bitcoin",
        "name": "bitlayer",
        "nativeToken": {
            "decimals": 18,
            "name": "Bitcoin",
            "symbol": "BTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.bitlayer.org"
            },
            {
                "http": "https://rpc.bitlayer-rpc.com"
            },
            {
                "http": "https://rpc.ankr.com/bitlayer"
            }
        ],
        "technicalStack": "other"
    },
    "blast": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/81457/etherscan/api",
                "family": "routescan",
                "name": "Blast Explorer",
                "url": "https://blastexplorer.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 81457,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Blast",
        "domainId": 81457,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-blast.safe.global",
        "name": "blast",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.blast.io"
            },
            {
                "http": "https://rpc.ankr.com/blast"
            }
        ],
        "technicalStack": "opstack"
    },
    "blastsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.blastscan.io/api",
                "family": "etherscan",
                "name": "Blast Sepolia Testnet Explorer",
                "url": "https://sepolia.blastscan.io/"
            }
        ],
        "chainId": 168587773,
        "deployer": {
            "name": "tmr",
            "url": "https://t.me/netimer"
        },
        "displayName": "Blast Sepolia Testnet",
        "domainId": 168587773,
        "isTestnet": true,
        "name": "blastsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.blast.io"
            }
        ]
    },
    "bob": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.gobob.xyz/api",
                "family": "blockscout",
                "name": "BOB Explorer",
                "url": "https://explorer.gobob.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 60808,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "BOB",
        "domainId": 60808,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.gobob.xyz",
        "name": "bob",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.gobob.xyz"
            }
        ],
        "technicalStack": "opstack"
    },
    "boba": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/288/etherscan/api",
                "family": "routescan",
                "name": "bobascan",
                "url": "https://bobascan.com"
            }
        ],
        "chainId": 288,
        "deployer": {
            "name": "Boba Network",
            "url": "https://boba.network"
        },
        "displayName": "Boba Mainnet",
        "domainId": 288,
        "isTestnet": false,
        "name": "boba",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.boba.network"
            }
        ]
    },
    "bobabnb": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/56288/etherscan/api",
                "family": "routescan",
                "name": "bobascan",
                "url": "https://bobascan.com"
            }
        ],
        "chainId": 56288,
        "deployer": {
            "name": "Boba Network",
            "url": "https://boba.network"
        },
        "displayName": "Boba BNB",
        "domainId": 56288,
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.boba.network/",
        "isTestnet": false,
        "name": "bobabnb",
        "nativeToken": {
            "decimals": 18,
            "name": "Boba Token",
            "symbol": "BOBA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://bnb.boba.network"
            }
        ]
    },
    "bobabnbtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/testnet/evm/9728/etherscan/api",
                "family": "routescan",
                "name": "bobascan",
                "url": "https://testnet.bobascan.com"
            }
        ],
        "chainId": 9728,
        "deployer": {
            "name": "Boba Network",
            "url": "https://boba.network"
        },
        "displayName": "Boba BNB Testnet",
        "domainId": 9728,
        "isTestnet": true,
        "name": "bobabnbtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Boba Token",
            "symbol": "BOBA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://testnet.bnb.boba.network"
            }
        ]
    },
    "bsc": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.bscscan.com/api",
                "family": "etherscan",
                "name": "BscScan",
                "url": "https://bscscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": "finalized"
        },
        "chainId": 56,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Binance Smart Chain",
        "displayNameShort": "Binance",
        "domainId": 56,
        "gasCurrencyCoinGeckoId": "binancecoin",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-bsc.safe.global/",
        "name": "bsc",
        "nativeToken": {
            "decimals": 18,
            "name": "BNB",
            "symbol": "BNB"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ankr.com/bsc"
            },
            {
                "http": "https://bsc.drpc.org"
            },
            {
                "http": "https://bscrpc.com"
            }
        ],
        "technicalStack": "other"
    },
    "bsctestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-testnet.bscscan.com/api",
                "family": "etherscan",
                "name": "BscScan",
                "url": "https://testnet.bscscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 9
        },
        "chainId": 97,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "BSC Testnet",
        "domainId": 97,
        "gasCurrencyCoinGeckoId": "binancecoin",
        "isTestnet": true,
        "name": "bsctestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "BNB",
            "symbol": "BNB"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://bsc-testnet.publicnode.com"
            },
            {
                "http": "https://bsc-testnet.blockpi.network/v1/rpc/public"
            }
        ]
    },
    "camptestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://camp-network-testnet.blockscout.com/api",
                "family": "blockscout",
                "name": "Camp Network Testnet Explorer",
                "url": "https://camp-network-testnet.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 325000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Camp Network Testnet V2",
        "domainId": 325000,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "camptestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-campnetwork.xyz"
            }
        ]
    },
    "canto": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.plexnode.wtf/api",
                "family": "blockscout",
                "name": "Canto Explorer",
                "url": "https://explorer.plexnode.wtf/"
            }
        ],
        "chainId": 7700,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Canto",
        "domainId": 7700,
        "isTestnet": false,
        "name": "canto",
        "nativeToken": {
            "decimals": 18,
            "name": "Canto",
            "symbol": "CANTO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://canto-rpc.ansybl.io"
            },
            {
                "http": "https://mainnode.plexnode.org:8545"
            },
            {
                "http": "https://canto.slingshot.finance"
            }
        ]
    },
    "cantotestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.tuber.build/api",
                "family": "blockscout",
                "name": "Canto Testnet Explorer",
                "url": "https://testnet.tuber.build/"
            }
        ],
        "chainId": 7701,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Canto Testnet",
        "domainId": 7701,
        "isTestnet": true,
        "name": "cantotestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Canto",
            "symbol": "CANTO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://canto-testnet.plexnode.wtf"
            },
            {
                "http": "https://testnet-archive.plexnode.wtf"
            }
        ]
    },
    "carbon": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm-scan.carbon.network/api",
                "family": "blockscout",
                "name": "Carbon Explorer",
                "url": "https://evm-scan.carbon.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 9790,
        "displayName": "Carbon",
        "domainId": 9790,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "carbon",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm-api.carbon.network"
            }
        ]
    },
    "celo": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.celoscan.io/api",
                "family": "etherscan",
                "name": "CeloScan",
                "url": "https://celoscan.io"
            },
            {
                "apiUrl": "https://explorer.celo.org/mainnet/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://explorer.celo.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 0
        },
        "chainId": 42220,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Celo",
        "domainId": 42220,
        "gasCurrencyCoinGeckoId": "celo",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-celo.safe.global/",
        "name": "celo",
        "nativeToken": {
            "decimals": 18,
            "name": "Celo",
            "symbol": "CELO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://forno.celo.org"
            }
        ],
        "technicalStack": "other"
    },
    "cheesechain": {
        "blockExplorers": [
            {
                "apiUrl": "https://fetascan.xyz/api",
                "family": "blockscout",
                "name": "Fetascan",
                "url": "https://fetascan.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 1
        },
        "chainId": 383353,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "CheeseChain",
        "domainId": 383353,
        "gasCurrencyCoinGeckoId": "cheese-2",
        "gnosisSafeTransactionServiceUrl": "https://prod.cheese.transaction.keypersafe.xyz/",
        "index": {
            "from": 50650
        },
        "name": "cheesechain",
        "nativeToken": {
            "decimals": 18,
            "name": "Cheese",
            "symbol": "CHEESE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://cheesechain.calderachain.xyz/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "chilizmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/88888/etherscan/api",
                "family": "routescan",
                "name": "Chiliscan",
                "url": "https://chiliscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 9
        },
        "chainId": 88888,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Chiliz",
        "domainId": 1000088888,
        "gasCurrencyCoinGeckoId": "chiliz",
        "name": "chilizmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Chiliz",
            "symbol": "CHZ"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ankr.com/chiliz"
            },
            {
                "http": "https://chiliz.publicnode.com"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "maxPriorityFeePerGas": 1000000000
        }
    },
    "citreatestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.testnet.citrea.xyz/api",
                "family": "blockscout",
                "name": "Citrea Testnet Explorer",
                "url": "https://explorer.testnet.citrea.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 5115,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Citrea Testnet",
        "domainId": 5115,
        "gasCurrencyCoinGeckoId": "bitcoin",
        "isTestnet": true,
        "name": "citreatestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Citrea BTC",
            "symbol": "cBTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.citrea.xyz"
            }
        ]
    },
    "clique": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.myclique.io/api",
                "family": "blockscout",
                "name": "Clique Explorer",
                "url": "https://explorer.myclique.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 8853,
        "displayName": "Clique",
        "domainId": 8853,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "clique",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.myclique.io"
            }
        ]
    },
    "confluxespace": {
        "blockExplorers": [
            {
                "apiUrl": "https://evmapi.confluxscan.net",
                "family": "other",
                "name": "ConfluxScan eSpace",
                "url": "https://evm.confluxscan.net"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 1030,
        "displayName": "Conflux eSpace",
        "domainId": 1030,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "confluxespace",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm.confluxrpc.com"
            }
        ]
    },
    "connextsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://scan.testnet.everclear.org/api",
                "family": "blockscout",
                "name": "Everclear Testnet Explorer",
                "url": "https://scan.testnet.everclear.org/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 10,
            "reorgPeriod": 0
        },
        "chainId": 6398,
        "deployer": {
            "name": "Everclear",
            "url": "https://everclear.org"
        },
        "displayName": "Everclear Sepolia",
        "domainId": 6398,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 4950
        },
        "isTestnet": true,
        "name": "connextsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.connext-sepolia.gelato.digital"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "coredao": {
        "blockExplorers": [
            {
                "apiUrl": "https://scan.coredao.org/api",
                "family": "other",
                "name": "Core Explorer",
                "url": "https://scan.coredao.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 21
        },
        "chainId": 1116,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Core",
        "domainId": 1116,
        "gasCurrencyCoinGeckoId": "coredaoorg",
        "name": "coredao",
        "nativeToken": {
            "decimals": 18,
            "name": "CoreDAO",
            "symbol": "CORE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.coredao.org"
            },
            {
                "http": "https://core.public.infstones.com"
            },
            {
                "http": "https://rpc.ankr.com/core"
            },
            {
                "http": "https://core.drpc.org"
            },
            {
                "http": "https://rpc-core.icecreamswap.com"
            }
        ],
        "technicalStack": "other"
    },
    "cosmoshub": {
        "bech32Prefix": "cosmos",
        "blockExplorers": [
            {
                "apiUrl": "https://apis.mintscan.io/v1/cosmos",
                "family": "other",
                "name": "MintScan",
                "url": "https://www.mintscan.io/cosmos"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 1
        },
        "canonicalAsset": "uatom",
        "chainId": "cosmoshub-4",
        "displayName": "Cosmos Hub",
        "domainId": 1668248429,
        "gasCurrencyCoinGeckoId": "cosmos",
        "grpcUrls": [
            {
                "http": "grpc-cosmoshub-ia.cosmosia.notional.ventures:443"
            },
            {
                "http": "cosmos-grpc.polkachu.com:14990"
            }
        ],
        "name": "cosmoshub",
        "nativeToken": {
            "decimals": 6,
            "denom": "uatom",
            "name": "Atom",
            "symbol": "ATOM"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://cosmos-lcd.quickapi.com:443"
            },
            {
                "http": "https://rest.cosmoshub.goldenratiostaking.net"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://cosmos-rpc.quickapi.com:443"
            },
            {
                "http": "https://rpc-cosmoshub.ecostake.com"
            }
        ],
        "slip44": 118,
        "technicalStack": "other"
    },
    "cronos": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.cronoscan.com/api",
                "family": "etherscan",
                "name": "Cronoscan Explorer",
                "url": "https://cronoscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 0
        },
        "chainId": 25,
        "displayName": "Cronos Mainnet",
        "domainId": 25,
        "gasCurrencyCoinGeckoId": "crypto-com-chain",
        "name": "cronos",
        "nativeToken": {
            "decimals": 18,
            "name": "Cronos",
            "symbol": "CRO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm.cronos.org"
            }
        ]
    },
    "cronoszkevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-api.zkevm.cronos.org/api/v1/contract/verify/hardhat",
                "family": "etherscan",
                "name": "Cronos zkEVM Explorer",
                "url": "https://explorer.zkevm.cronos.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 388,
        "displayName": "Cronos zkEVM",
        "domainId": 388,
        "gasCurrencyCoinGeckoId": "crypto-com-chain",
        "name": "cronoszkevm",
        "nativeToken": {
            "decimals": 18,
            "name": "Cronos",
            "symbol": "CRO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.zkevm.cronos.org"
            }
        ]
    },
    "cyber": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.socialscan.io/cyber",
                "family": "other",
                "name": "Cyber Mainnet Explorer",
                "url": "https://cyberscan.co"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 7560,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Cyber",
        "domainId": 7560,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "cyber",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.cyber.co"
            },
            {
                "http": "https://cyber.alt.technology"
            }
        ],
        "technicalStack": "opstack"
    },
    "degenchain": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.degen.tips/api/eth-rpc",
                "family": "blockscout",
                "name": "Degen Chain Explorer",
                "url": "https://explorer.degen.tips"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 10,
            "reorgPeriod": 5
        },
        "chainId": 666666666,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Degen",
        "domainId": 666666666,
        "gasCurrencyCoinGeckoId": "degen-base",
        "index": {
            "from": 23783929
        },
        "name": "degenchain",
        "nativeToken": {
            "decimals": 18,
            "name": "Degen",
            "symbol": "DEGEN"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.degen.tips"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "deprecatedalephzeroevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm-explorer.alephzero.org/api",
                "family": "blockscout",
                "name": "Aleph Zero Explorer",
                "url": "https://evm-explorer.alephzero.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 41455,
        "displayName": "DEPRECATED Aleph Zero EVM",
        "displayNameShort": "DEPRECATED Aleph Zero EVM",
        "domainId": 41455,
        "gasCurrencyCoinGeckoId": "aleph-zero",
        "index": {
            "from": 3421962
        },
        "name": "deprecatedalephzeroevm",
        "nativeToken": {
            "decimals": 18,
            "name": "AZERO",
            "symbol": "AZERO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.alephzero.raas.gelato.cloud"
            },
            {
                "http": "https://alephzero.drpc.org"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "deprecatedchiliz": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/88888/etherscan/api",
                "family": "routescan",
                "name": "Chiliscan",
                "url": "https://chiliscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 9
        },
        "chainId": 88888,
        "displayName": "DEPRECATED Chiliz",
        "domainId": 88888,
        "gasCurrencyCoinGeckoId": "chiliz",
        "name": "deprecatedchiliz",
        "nativeToken": {
            "decimals": 18,
            "name": "Chiliz",
            "symbol": "CHZ"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ankr.com/chiliz"
            },
            {
                "http": "https://chiliz.publicnode.com"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "maxPriorityFeePerGas": 1000000000
        }
    },
    "deprecatedflow": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm.flowscan.io/api",
                "family": "blockscout",
                "name": "EVM on Flow Explorer",
                "url": "https://evm.flowscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 25
        },
        "chainId": 747,
        "displayName": "DEPRECATED Flow EVM",
        "domainId": 747,
        "gasCurrencyCoinGeckoId": "flow",
        "isTestnet": false,
        "name": "deprecatedflow",
        "nativeToken": {
            "decimals": 18,
            "name": "Flow",
            "symbol": "FLOW"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.evm.nodes.onflow.org"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "gasPrice": 100000000
        }
    },
    "deprecatedimmutablezkevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.immutable.com/api/eth-rpc",
                "family": "blockscout",
                "name": "Immutable Explorer",
                "url": "https://explorer.immutable.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 20
        },
        "chainId": 13371,
        "displayName": "DEPRECATED Immutable zkEVM",
        "domainId": 13371,
        "gasCurrencyCoinGeckoId": "immutable-x",
        "name": "deprecatedimmutablezkevm",
        "nativeToken": {
            "decimals": 18,
            "name": "Immutable",
            "symbol": "IMX"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.immutable.com"
            },
            {
                "http": "https://immutable.gateway.tenderly.co"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "maxFeePerGas": 100000000000,
            "maxPriorityFeePerGas": 100000000000
        }
    },
    "deprecatedmetall2": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.metall2.com/api",
                "family": "blockscout",
                "name": "Metal L2 Explorer",
                "url": "https://explorer.metall2.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 1750,
        "displayName": "DEPRECATED Metal L2",
        "domainId": 1750,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": false,
        "name": "deprecatedmetall2",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.metall2.com"
            }
        ],
        "technicalStack": "opstack"
    },
    "deprecatedpolynomial": {
        "blockExplorers": [
            {
                "apiUrl": "https://polynomialscan.io/api",
                "family": "routescan",
                "name": "Polynomial Explorer",
                "url": "https://polynomialscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 8008,
        "displayName": "DEPRECATED Polynomial",
        "domainId": 8008,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "deprecatedpolynomial",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.polynomial.fi"
            }
        ],
        "technicalStack": "opstack"
    },
    "deprecatedrari": {
        "blockExplorers": [
            {
                "apiUrl": "https://mainnet.explorer.rarichain.org/api",
                "family": "blockscout",
                "name": "Rari Mainnet Explorer",
                "url": "https://mainnet.explorer.rarichain.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 0
        },
        "chainId": 1380012617,
        "displayName": "DEPRECATED RARI Chain",
        "domainId": 1380012617,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 541753
        },
        "name": "deprecatedrari",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.rpc.rarichain.org/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "deprecatedrootstock": {
        "blockExplorers": [
            {
                "apiUrl": "https://rootstock.blockscout.com/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://rootstock.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 4
        },
        "chainId": 30,
        "displayName": "DEPRECATED Rootstock",
        "domainId": 30,
        "gasCurrencyCoinGeckoId": "rootstock",
        "name": "deprecatedrootstock",
        "nativeToken": {
            "decimals": 18,
            "name": "Rootstock Smart Bitcoin",
            "symbol": "RBTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mainnet.rootstock.io/kXhXHf6TnnfW1POvr4UT0YUvujmuju-M"
            },
            {
                "http": "https://public-node.rsk.co"
            },
            {
                "http": "https://mycrypto.rsk.co"
            }
        ],
        "technicalStack": "other"
    },
    "deprecatedsuperposition": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.superposition.so/api",
                "family": "blockscout",
                "name": "Superposition Explorer",
                "url": "https://explorer.superposition.so/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 60,
            "reorgPeriod": 0
        },
        "chainId": 55244,
        "displayName": "DEPRECATED Superposition",
        "domainId": 55244,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 1201
        },
        "name": "deprecatedsuperposition",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.superposition.so"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "dodotestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet-scan.dodochain.com/api",
                "family": "blockscout",
                "name": "DODOchain Explorer",
                "url": "https://testnet-scan.dodochain.com"
            }
        ],
        "blocks": {
            "confirmations": 0,
            "estimateBlockTime": 13,
            "reorgPeriod": 0
        },
        "chainId": 53457,
        "deployer": {
            "name": "DODO",
            "url": "http://dodoex.io"
        },
        "displayName": "DODOChain",
        "domainId": 53457,
        "index": {
            "from": 2000
        },
        "isTestnet": true,
        "name": "dodotestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "DODO",
            "symbol": "DODO"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://dodochain-testnet.alt.technology"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "dogechain": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.dogechain.dog/api",
                "family": "blockscout",
                "name": "Dogechain Explorer",
                "url": "https://explorer.dogechain.dog"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 2000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Dogechain",
        "domainId": 2000,
        "gasCurrencyCoinGeckoId": "dogecoin",
        "name": "dogechain",
        "nativeToken": {
            "decimals": 18,
            "name": "Dogecoin",
            "symbol": "DOGE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.dogechain.dog"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "ebi": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.ebi.xyz/api",
                "family": "blockscout",
                "name": "Ebi Explorer",
                "url": "https://explorer.ebi.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 98881,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Ebi",
        "domainId": 98881,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 10689437
        },
        "name": "ebi",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ebi.xyz"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "eclipsemainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.eclipse.xyz/api",
                "family": "other",
                "name": "Eclipse Explorer",
                "url": "https://explorer.eclipse.xyz/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.4,
            "reorgPeriod": 0
        },
        "chainId": 1408864445,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Eclipse",
        "domainId": 1408864445,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "eclipsemainnet",
        "nativeToken": {
            "decimals": 9,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "sealevel",
        "rpcUrls": [
            {
                "http": "https://mainnetbeta-rpc.eclipse.xyz"
            }
        ],
        "technicalStack": "other"
    },
    "eclipsetestnet": {
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.4,
            "reorgPeriod": 0
        },
        "chainId": 239092742,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Eclipse Testnet",
        "domainId": 239092742,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "eclipsetestnet",
        "nativeToken": {
            "decimals": 9,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "sealevel",
        "rpcUrls": [
            {
                "http": "https://testnet.dev2.eclipsenetwork.xyz"
            }
        ]
    },
    "ecotestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://eco-testnet.explorer.caldera.xyz/api",
                "family": "blockscout",
                "name": "ECO Testnet explorer",
                "url": "https://eco-testnet.explorer.caldera.xyz/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 471923,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Eco Testnet",
        "domainId": 471923,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "ecotestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://eco-testnet.rpc.caldera.xyz/http"
            }
        ]
    },
    "endurance": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-endurance.fusionist.io/api",
                "family": "blockscout",
                "name": "Endurance Explorer",
                "url": "https://explorer-endurance.fusionist.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 12,
            "reorgPeriod": 15
        },
        "chainId": 648,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Endurance",
        "domainId": 648,
        "gasCurrencyCoinGeckoId": "endurance",
        "gnosisSafeTransactionServiceUrl": "https://safewallet.fusionist.io/cgw/api",
        "name": "endurance",
        "nativeToken": {
            "decimals": 18,
            "name": "Fusionist",
            "symbol": "ACE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-endurance.fusionist.io"
            }
        ],
        "technicalStack": "other"
    },
    "ethereum": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.etherscan.io/api",
                "family": "etherscan",
                "name": "Etherscan",
                "url": "https://etherscan.io"
            },
            {
                "apiUrl": "https://eth.blockscout.com/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://blockscout.com/eth/mainnet"
            }
        ],
        "blocks": {
            "confirmations": 2,
            "estimateBlockTime": 13,
            "reorgPeriod": 15
        },
        "chainId": 1,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Ethereum",
        "domainId": 1,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-mainnet.safe.global/",
        "name": "ethereum",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://ethereum.publicnode.com"
            },
            {
                "http": "https://cloudflare-eth.com"
            }
        ],
        "technicalStack": "other"
    },
    "euphoriatestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://euphoria-api.aurascan.io",
                "family": "other",
                "name": "AuraScan",
                "url": "https://euphoria.aurascan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 0
        },
        "chainId": 6321,
        "deployer": {
            "name": "hoanm",
            "url": "https://github.com/hoanm"
        },
        "displayName": "Euphoria Testnet",
        "domainId": 6321,
        "isTestnet": true,
        "name": "euphoriatestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Euphoria Aura",
            "symbol": "EAURA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://jsonrpc.euphoria.aura.network"
            }
        ]
    },
    "everclear": {
        "blockExplorers": [
            {
                "apiUrl": "https://scan.everclear.org/api",
                "family": "blockscout",
                "name": "Everclear Explorer",
                "url": "https://scan.everclear.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 2
        },
        "chainId": 25327,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Everclear",
        "domainId": 25327,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 37
        },
        "name": "everclear",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.everclear.raas.gelato.cloud"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "fantom": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.ftmscan.com/api",
                "family": "etherscan",
                "name": "FTMScan",
                "url": "https://ftmscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 250,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Fantom Opera",
        "domainId": 250,
        "gasCurrencyCoinGeckoId": "fantom",
        "name": "fantom",
        "nativeToken": {
            "decimals": 18,
            "name": "Fantom",
            "symbol": "FTM"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpcapi.fantom.network"
            },
            {
                "http": "https://fantom-rpc.publicnode.com"
            },
            {
                "http": "https://fantom-pokt.nodies.app"
            },
            {
                "http": "https://rpc.fantom.network"
            },
            {
                "http": "https://rpc2.fantom.network"
            },
            {
                "http": "https://rpc3.fantom.network"
            }
        ],
        "technicalStack": "other"
    },
    "fhenixtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.helium.fhenix.zone",
                "family": "blockscout",
                "name": "Fhenix Helium Testnet Explorer",
                "url": "https://explorer.helium.fhenix.zone"
            }
        ],
        "chainId": 8008135,
        "deployer": {
            "name": "d0x471b",
            "url": "https://t.me/d0x471b"
        },
        "displayName": "Fhenix Helium Testnet",
        "domainId": 8008135,
        "index": {
            "from": 140556
        },
        "isTestnet": true,
        "name": "fhenixtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Testnet Fhenix",
            "symbol": "tFHE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.helium.fhenix.zone"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "filecoin": {
        "blockExplorers": [
            {
                "apiUrl": "https://filecoin.blockscout.com/api",
                "family": "blockscout",
                "name": "Filecoin VM Explorer",
                "url": "https://filecoin.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 0
        },
        "chainId": 314,
        "displayName": "Filecoin",
        "domainId": 314,
        "gasCurrencyCoinGeckoId": "filecoin",
        "name": "filecoin",
        "nativeToken": {
            "decimals": 18,
            "name": "Filecoin",
            "symbol": "FIL"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.node.glif.io/rpc/v1"
            },
            {
                "http": "https://rpc.ankr.com/filecoin"
            }
        ]
    },
    "flame": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.flame.astria.org/api",
                "family": "blockscout",
                "name": "Astria Flame Explorer",
                "url": "https://explorer.flame.astria.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 253368190,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Flame",
        "domainId": 253368190,
        "gasCurrencyCoinGeckoId": "celestia",
        "name": "flame",
        "nativeToken": {
            "decimals": 18,
            "name": "Celestia",
            "symbol": "TIA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.flame.astria.org"
            }
        ],
        "technicalStack": "other"
    },
    "flare": {
        "blockExplorers": [
            {
                "apiUrl": "https://flare-explorer.flare.network/api",
                "family": "blockscout",
                "name": "Flare Explorer",
                "url": "https://flare-explorer.flare.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 3
        },
        "chainId": 14,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Flare",
        "domainId": 14,
        "gasCurrencyCoinGeckoId": "flare-networks",
        "name": "flare",
        "nativeToken": {
            "decimals": 18,
            "name": "Flare",
            "symbol": "FLR"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://flare-api.flare.network/ext/C/rpc"
            },
            {
                "http": "https://flare.solidifi.app/ext/C/rpc"
            },
            {
                "http": "https://flare.rpc.thirdweb.com"
            },
            {
                "http": "https://rpc.ankr.com/flare"
            }
        ],
        "technicalStack": "other"
    },
    "flowmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://evm.flowscan.io/api",
                "family": "blockscout",
                "name": "EVM on Flow Explorer",
                "url": "https://evm.flowscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 25
        },
        "chainId": 747,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "EVM on Flow",
        "domainId": 1000000747,
        "gasCurrencyCoinGeckoId": "flow",
        "isTestnet": false,
        "name": "flowmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Flow",
            "symbol": "FLOW"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.evm.nodes.onflow.org"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "gasPrice": 100000000
        }
    },
    "forma": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.forma.art/api",
                "family": "blockscout",
                "name": "Forma Explorer",
                "url": "https://explorer.forma.art"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 0
        },
        "chainId": 984122,
        "deployer": {
            "name": "Codecrafting Labs",
            "url": "https://cclabs.tech"
        },
        "displayName": "Forma",
        "displayNameShort": "Forma",
        "domainId": 984122,
        "gasCurrencyCoinGeckoId": "celestia",
        "name": "forma",
        "nativeToken": {
            "decimals": 18,
            "name": "TIA",
            "symbol": "TIA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.forma.art"
            }
        ]
    },
    "formtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.form.network/api",
                "family": "blockscout",
                "name": "Form Testnet Explorer",
                "url": "https://explorer.form.network"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 132902,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Form Testnet",
        "domainId": 132902,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "formtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://testnet-rpc.form.network/http"
            }
        ]
    },
    "fractalconfluence": {
        "blockExplorers": [
            {
                "apiUrl": "https://evmscan.fra.tech/api",
                "family": "blockscout",
                "name": "Fractal Confluence Explorer",
                "url": "https://evmscan.fra.tech"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 24,
            "reorgPeriod": 0
        },
        "chainId": 2152,
        "displayName": "Fractal Confluence",
        "domainId": 2152,
        "gasCurrencyCoinGeckoId": "findora",
        "name": "fractalconfluence",
        "nativeToken": {
            "decimals": 18,
            "name": "Fractal",
            "symbol": "FRA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-mainnet.fra.tech"
            },
            {
                "http": "https://mainnet.fra.tech:8545"
            }
        ]
    },
    "fraxtal": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.fraxscan.com/api",
                "family": "etherscan",
                "name": "Fraxscan",
                "url": "https://fraxscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 252,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Fraxtal",
        "domainId": 252,
        "gasCurrencyCoinGeckoId": "frax-ether",
        "gnosisSafeTransactionServiceUrl": "https://transaction-frax.safe.optimism.io",
        "name": "fraxtal",
        "nativeToken": {
            "decimals": 18,
            "name": "Frax Ether",
            "symbol": "frxETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.frax.com"
            },
            {
                "http": "https://fraxtal.drpc.org"
            }
        ],
        "technicalStack": "opstack"
    },
    "fraxtaltestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-holesky.fraxscan.com/api",
                "family": "etherscan",
                "name": "Fraxtal Testnet Explorer",
                "url": "https://holesky.fraxscan.com/"
            }
        ],
        "chainId": 2522,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Fraxtal Testnet",
        "domainId": 2522,
        "isTestnet": true,
        "name": "fraxtaltestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Frax Ether",
            "symbol": "frxETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.frax.com"
            }
        ]
    },
    "fuji": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/testnet/evm/43113/etherscan/api",
                "family": "etherscan",
                "name": "SnowTrace",
                "url": "https://testnet.snowtrace.io"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": 3
        },
        "chainId": 43113,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Fuji",
        "domainId": 43113,
        "gasCurrencyCoinGeckoId": "avalanche-2",
        "isTestnet": true,
        "name": "fuji",
        "nativeToken": {
            "decimals": 18,
            "name": "Avalanche",
            "symbol": "AVAX"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.avax-test.network/ext/bc/C/rpc",
                "pagination": {
                    "maxBlockRange": 2048
                }
            }
        ]
    },
    "funki": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/mainnet/evm/33979_2/etherscan/api",
                "family": "routescan",
                "name": "Funkiscan",
                "url": "https://funkiscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 33979,
        "displayName": "Funki",
        "domainId": 33979,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "funki",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-mainnet.funkichain.com"
            }
        ]
    },
    "fusemainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.fuse.io/api",
                "family": "etherscan",
                "name": "FuseExplorer",
                "url": "https://explorer.fuse.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 19
        },
        "chainId": 122,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Fuse",
        "domainId": 122,
        "gasCurrencyCoinGeckoId": "fuse-network-token",
        "gnosisSafeTransactionServiceUrl": "https://transaction-fuse.safe.fuse.io",
        "name": "fusemainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "FUSE",
            "symbol": "FUSE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.fuse.io"
            },
            {
                "http": "https://fuse.drpc.org"
            },
            {
                "http": "https://fuse.liquify.com"
            },
            {
                "http": "https://fuse-pokt.nodies.app"
            }
        ],
        "technicalStack": "other"
    },
    "galadrieldevnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.galadriel.com/",
                "family": "blockscout",
                "name": "Galadriel Devnet explorer",
                "url": "https://explorer.galadriel.com/"
            }
        ],
        "chainId": 696969,
        "deployer": {
            "name": "remsee",
            "url": "https://t.me/remsee90"
        },
        "displayName": "Galadriel Devnet",
        "domainId": 696969,
        "isTestnet": true,
        "name": "galadrieldevnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://devnet.galadriel.com"
            }
        ]
    },
    "gnosis": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.gnosisscan.io/api",
                "family": "etherscan",
                "name": "GnosisScan",
                "url": "https://gnosisscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 5
        },
        "chainId": 100,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Gnosis",
        "domainId": 100,
        "gasCurrencyCoinGeckoId": "xdai",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-gnosis-chain.safe.global/",
        "name": "gnosis",
        "nativeToken": {
            "decimals": 18,
            "name": "xDai",
            "symbol": "xDai"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.gnosischain.com",
                "pagination": {
                    "maxBlockRange": 10000,
                    "minBlockNumber": 25997478
                }
            }
        ],
        "technicalStack": "other"
    },
    "gravity": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.gravity.xyz/api",
                "family": "blockscout",
                "name": "Gravity Alpha Explorer",
                "url": "https://explorer.gravity.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 5
        },
        "chainId": 1625,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Gravity Alpha Mainnet",
        "displayNameShort": "Gravity",
        "domainId": 1625,
        "gasCurrencyCoinGeckoId": "g-token",
        "index": {
            "from": 13374779
        },
        "name": "gravity",
        "nativeToken": {
            "decimals": 18,
            "name": "Gravity",
            "symbol": "G"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.gravity.xyz"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "ham": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.ham.fun/api",
                "family": "blockscout",
                "name": "Ham Explorer",
                "url": "https://explorer.ham.fun"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 5112,
        "displayName": "Ham",
        "domainId": 5112,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "ham",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.ham.fun"
            }
        ]
    },
    "harmony": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.harmony.one/api",
                "family": "blockscout",
                "name": "Harmony Explorer",
                "url": "https://explorer.harmony.one"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 1666600000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Harmony One",
        "domainId": 1666600000,
        "gasCurrencyCoinGeckoId": "harmony",
        "name": "harmony",
        "nativeToken": {
            "decimals": 18,
            "name": "ONE",
            "symbol": "ONE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.harmony.one"
            },
            {
                "http": "https://api.s0.t.hmny.io"
            },
            {
                "http": "https://1rpc.io/one"
            },
            {
                "http": "https://rpc.ankr.com/harmony"
            }
        ],
        "technicalStack": "other"
    },
    "harmonytestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.testnet.harmony.one/api/v2",
                "family": "blockscout",
                "name": "Harmony Testnet Explorer",
                "url": "https://explorer.testnet.harmony.one/"
            }
        ],
        "chainId": 1666700000,
        "deployer": {
            "name": "JaunePomme",
            "url": "https://github.com/JaunePomme"
        },
        "displayName": "Harmony Testnet",
        "domainId": 1666700000,
        "isTestnet": true,
        "name": "harmonytestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "ONE",
            "symbol": "ONE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.s0.b.hmny.io"
            }
        ]
    },
    "heneztestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://henez-testnet.explorer.caldera.xyz/api/eth-rpc",
                "family": "blockscout",
                "name": "Henez Testnet Explorer",
                "url": "https://explorer.henez.fi"
            }
        ],
        "chainId": 91111,
        "deployer": {
            "name": "Henez Foundation",
            "url": "https://www.henez.fi"
        },
        "displayName": "Henez Testnet",
        "domainId": 91111,
        "index": {
            "from": 1714457
        },
        "isTestnet": true,
        "name": "heneztestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://henez-testnet.rpc.caldera.xyz/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "holesky": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-holesky.etherscan.io/api",
                "family": "etherscan",
                "name": "Etherscan",
                "url": "https://holesky.etherscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 13,
            "reorgPeriod": 2
        },
        "chainId": 17000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Holesky",
        "domainId": 17000,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "holesky",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://ethereum-holesky-rpc.publicnode.com"
            }
        ]
    },
    "humanitytestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.testnet.humanity.org/api",
                "family": "blockscout",
                "name": "Humanity Protocol Testnet Explorer",
                "url": "https://explorer.testnet.humanity.org"
            }
        ],
        "chainId": 1942999413,
        "deployer": {
            "name": "JunayedMh",
            "url": "https://github.com/JunayedMh"
        },
        "displayName": "Humanity Protocol Testnet",
        "domainId": 1942999413,
        "isTestnet": true,
        "name": "humanitytestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Humanity Protocol",
            "symbol": "tHP"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.humanity.org"
            }
        ]
    },
    "hyperliquidevmtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.hyperlend.finance/api",
                "family": "blockscout",
                "name": "Hyperliquid EVM Testnet Explorer",
                "url": "https://explorer.hyperlend.finance"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 998,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Hyperliquid EVM Testnet",
        "domainId": 998,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "hyperliquidevmtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.hyperliquid-testnet.xyz/evm"
            }
        ]
    },
    "immutablezkevmmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.immutable.com/api/eth-rpc",
                "family": "blockscout",
                "name": "Immutable Explorer",
                "url": "https://explorer.immutable.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 20
        },
        "chainId": 13371,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Immutable zkEVM",
        "domainId": 1000013371,
        "gasCurrencyCoinGeckoId": "immutable-x",
        "name": "immutablezkevmmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Immutable",
            "symbol": "IMX"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.immutable.com"
            },
            {
                "http": "https://immutable.gateway.tenderly.co"
            }
        ],
        "technicalStack": "other",
        "transactionOverrides": {
            "maxFeePerGas": 100000000000,
            "maxPriorityFeePerGas": 100000000000
        }
    },
    "inevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://inevm.calderaexplorer.xyz/api",
                "family": "blockscout",
                "name": "Caldera inEVM Explorer",
                "url": "https://inevm.calderaexplorer.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 3
        },
        "chainId": 2525,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Injective EVM",
        "displayNameShort": "inEVM",
        "domainId": 2525,
        "gasCurrencyCoinGeckoId": "injective-protocol",
        "index": {
            "from": 37
        },
        "name": "inevm",
        "nativeToken": {
            "decimals": 18,
            "name": "Injective",
            "symbol": "INJ"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://inevm.calderachain.xyz/http"
            },
            {
                "http": "https://mainnet.rpc.inevm.com/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "injective": {
        "bech32Prefix": "inj",
        "blockExplorers": [
            {
                "apiUrl": "https://apis.mintscan.io/v1/injective",
                "family": "other",
                "name": "Mintscan",
                "url": "https://www.mintscan.io/injective"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 10
        },
        "canonicalAsset": "inj",
        "chainId": "injective-1",
        "contractAddressBytes": 20,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Injective",
        "domainId": 6909546,
        "gasCurrencyCoinGeckoId": "injective-protocol",
        "gasPrice": {
            "amount": "700000000",
            "denom": "inj"
        },
        "grpcUrls": [
            {
                "http": "https://injective-grpc.goldenratiostaking.net:443"
            }
        ],
        "index": {
            "chunk": 25,
            "from": 58419500
        },
        "name": "injective",
        "nativeToken": {
            "decimals": 18,
            "denom": "inj",
            "name": "Injective",
            "symbol": "INJ"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://sentry.lcd.injective.network:443"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://sentry.tm.injective.network:443"
            }
        ],
        "slip44": 118,
        "technicalStack": "other"
    },
    "inksepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-sepolia.inkonchain.com/api",
                "family": "blockscout",
                "name": "https://explorer-sepolia.inkonchain.com",
                "url": "https://explorer-sepolia.inkonchain.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 763373,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Ink Sepolia",
        "domainId": 763373,
        "isTestnet": true,
        "name": "inksepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-qnd-sepolia.inkonchain.com"
            }
        ],
        "technicalStack": "opstack"
    },
    "kaia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-cypress.klaytnscope.com/api",
                "family": "etherscan",
                "name": "Kaiascope",
                "url": "https://kaiascope.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 5
        },
        "chainId": 8217,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Kaia",
        "domainId": 8217,
        "gasCurrencyCoinGeckoId": "kaia",
        "name": "kaia",
        "nativeToken": {
            "decimals": 18,
            "name": "Kaia",
            "symbol": "KLAY"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://public-en.node.kaia.io"
            }
        ],
        "technicalStack": "other"
    },
    "kalychain": {
        "blockExplorers": [
            {
                "apiUrl": "https://kalyscan.io/api",
                "family": "blockscout",
                "name": "KalyScan",
                "url": "https://kalyscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 2
        },
        "chainId": 3888,
        "deployer": {
            "name": "Kaly Chain",
            "url": "https://www.kalychain.io"
        },
        "displayName": "KalyChain",
        "domainId": 3888,
        "name": "kalychain",
        "nativeToken": {
            "decimals": 18,
            "name": "KalyCoin",
            "symbol": "KLC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.kalychain.io/rpc"
            }
        ]
    },
    "kava": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.kava.io/api",
                "family": "blockscout",
                "name": "Kava Explorer",
                "url": "https://explorer.kava.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 0
        },
        "chainId": 2222,
        "displayName": "Kava",
        "domainId": 2222,
        "gasCurrencyCoinGeckoId": "kava",
        "name": "kava",
        "nativeToken": {
            "decimals": 18,
            "name": "Kava",
            "symbol": "KAVA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm.kava-rpc.com"
            },
            {
                "http": "https://evm.kava.chainstacklabs.com"
            },
            {
                "http": "https://rpc.ankr.com/kava_evm"
            },
            {
                "http": "https://evm.kava.io"
            },
            {
                "http": "https://kava.drpc.org"
            }
        ]
    },
    "kinto": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.kinto.xyz/api/eth-rpc",
                "family": "blockscout",
                "name": "Kinto Explorer",
                "url": "https://explorer.kinto.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 0
        },
        "chainId": 7887,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Kinto",
        "domainId": 7887,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 215193
        },
        "name": "kinto",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://kinto-mainnet.calderachain.xyz/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "koitestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://koi-scan.darwinia.network/api",
                "family": "blockscout",
                "name": "Koi Explorer",
                "url": "https://koi-scan.darwinia.network/"
            }
        ],
        "chainId": 701,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Koi Testnet",
        "domainId": 701,
        "isTestnet": true,
        "name": "koitestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "kring",
            "symbol": "KRING"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://koi-rpc.darwinia.network"
            }
        ]
    },
    "kroma": {
        "blockExplorers": [
            {
                "apiUrl": "https://blockscout.kroma.network/api",
                "family": "blockscout",
                "name": "Kroma Explorer",
                "url": "https://blockscout.kroma.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 255,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Kroma",
        "domainId": 255,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "kroma",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-kroma.rockx.com"
            },
            {
                "http": "https://api.kroma.network"
            },
            {
                "http": "https://1rpc.io/kroma"
            }
        ],
        "technicalStack": "opstack"
    },
    "linea": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.lineascan.build/api",
                "family": "etherscan",
                "name": "LineaScan",
                "url": "https://lineascan.build"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 59144,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Linea",
        "domainId": 59144,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-linea.safe.global",
        "name": "linea",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.linea.build"
            },
            {
                "http": "https://linea.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://1rpc.io/linea"
            },
            {
                "http": "https://linea.drpc.org"
            }
        ],
        "technicalStack": "other"
    },
    "lisk": {
        "blockExplorers": [
            {
                "apiUrl": "https://blockscout.lisk.com/api/eth-rpc",
                "family": "blockscout",
                "name": "Lisk Explorer",
                "url": "https://blockscout.lisk.com"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 1135,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Lisk",
        "domainId": 1135,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "lisk",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.api.lisk.com"
            }
        ],
        "technicalStack": "opstack"
    },
    "lisksepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://sepolia-blockscout.lisk.com/api",
                "family": "blockscout",
                "name": "Lisk Sepolia Testnet Explorer",
                "url": "https://sepolia-blockscout.lisk.com/"
            }
        ],
        "chainId": 4202,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Lisk Sepolia",
        "domainId": 4202,
        "isTestnet": true,
        "name": "lisksepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.sepolia-api.lisk.com"
            }
        ]
    },
    "lukso": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.execution.mainnet.lukso.network/api",
                "family": "blockscout",
                "name": "LUKSO Mainnet Explorer",
                "url": "https://explorer.execution.mainnet.lukso.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 12,
            "reorgPeriod": 15
        },
        "chainId": 42,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "LUKSO",
        "domainId": 42,
        "gasCurrencyCoinGeckoId": "lukso-token-2",
        "name": "lukso",
        "nativeToken": {
            "decimals": 18,
            "name": "LUKSO",
            "symbol": "LYX"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mainnet.lukso.network"
            },
            {
                "http": "https://rpc.lukso.sigmacore.io"
            },
            {
                "http": "https://42.rpc.thirdweb.com"
            }
        ],
        "technicalStack": "other"
    },
    "luksotestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.explorer.execution.testnet.lukso.network/api",
                "family": "blockscout",
                "name": "LUKSO Testnet Explorer",
                "url": "https://explorer.execution.testnet.lukso.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 12,
            "reorgPeriod": 14
        },
        "chainId": 4201,
        "deployer": {
            "name": "Hashi",
            "url": "https://crosschain-alliance.gitbook.io/hashi"
        },
        "displayName": "LUKSO Testnet",
        "domainId": 4201,
        "isTestnet": true,
        "name": "luksotestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Testnet LUKSO",
            "symbol": "LYXt"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.lukso.network"
            }
        ]
    },
    "lumia": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.lumia.org/api/eth-rpc",
                "family": "blockscout",
                "name": "Lumia Prism Explorer",
                "url": "https://explorer.lumia.org"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 4,
            "reorgPeriod": 5
        },
        "chainId": 994873017,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Lumia Prism",
        "domainId": 994873017,
        "gasCurrencyCoinGeckoId": "orion-protocol",
        "index": {
            "from": 1923136
        },
        "name": "lumia",
        "nativeToken": {
            "decimals": 18,
            "name": "Lumia",
            "symbol": "LUMIA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet-rpc.lumia.org"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "lumiaprism": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.lumia.org/api/eth-rpc",
                "family": "blockscout",
                "name": "Lumia Prism Explorer",
                "url": "https://explorer.lumia.org"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 4,
            "reorgPeriod": 5
        },
        "chainId": 994873017,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Lumia Prism",
        "domainId": 1000073017,
        "gasCurrencyCoinGeckoId": "lumia",
        "name": "lumiaprism",
        "nativeToken": {
            "decimals": 18,
            "name": "Lumia",
            "symbol": "LUMIA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet-rpc.lumia.org"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "mantapacific": {
        "blockExplorers": [
            {
                "apiUrl": "https://pacific-explorer.manta.network/api",
                "family": "blockscout",
                "name": "Manta Pacific Explorer",
                "url": "https://pacific-explorer.manta.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 169,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Manta Pacific",
        "displayNameShort": "Manta",
        "domainId": 169,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.manta.network",
        "isTestnet": false,
        "name": "mantapacific",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://pacific-rpc.manta.network/http"
            },
            {
                "http": "https://manta.nirvanalabs.xyz/mantapublic"
            }
        ],
        "technicalStack": "opstack"
    },
    "mantapacifictestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://pacific-explorer.sepolia-testnet.manta.network/api",
                "family": "blockscout",
                "name": "Manta Sepolia Explorer",
                "url": "https://pacific-explorer.sepolia-testnet.manta.network"
            }
        ],
        "chainId": 3441006,
        "deployer": {
            "name": "JaunePomme",
            "url": "https://github.com/JaunePomme"
        },
        "displayName": "Manta Pacific Testnet",
        "domainId": 3441006,
        "isTestnet": true,
        "name": "mantapacifictestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://pacific-rpc.sepolia-testnet.manta.network/http"
            }
        ]
    },
    "mantle": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.mantle.xyz/api",
                "family": "blockscout",
                "name": "Mantle Mainnet Explorer",
                "url": "https://explorer.mantle.xyz"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": 2
        },
        "chainId": 5000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Mantle",
        "domainId": 5000,
        "gasCurrencyCoinGeckoId": "mantle",
        "gnosisSafeTransactionServiceUrl": "https://transaction.multisig.mantle.xyz",
        "name": "mantle",
        "nativeToken": {
            "decimals": 18,
            "name": "Mantle",
            "symbol": "MNT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mantle.xyz"
            }
        ],
        "technicalStack": "opstack"
    },
    "mantlesepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.mantlescan.xyz/api",
                "family": "etherscan",
                "name": "Mantle Testnet Explorer",
                "url": "https://sepolia.mantlescan.xyz/"
            }
        ],
        "chainId": 5003,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Mantle Sepolia",
        "domainId": 5003,
        "isTestnet": true,
        "name": "mantlesepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Mantle",
            "symbol": "MNT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.sepolia.mantle.xyz"
            }
        ]
    },
    "merlin": {
        "blockExplorers": [
            {
                "apiUrl": "https://scan.merlinchain.io/api",
                "family": "other",
                "name": "Merlin Explorer",
                "url": "https://scan.merlinchain.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 5
        },
        "chainId": 4200,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Merlin",
        "domainId": 4200,
        "gasCurrencyCoinGeckoId": "merlin-chain-bridged-wrapped-btc-merlin",
        "name": "merlin",
        "nativeToken": {
            "decimals": 18,
            "name": "Bitcoin",
            "symbol": "BTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.merlinchain.io"
            },
            {
                "http": "https://merlin.blockpi.network/v1/rpc/public"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "metal": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.metall2.com/api",
                "family": "blockscout",
                "name": "Metal L2 Explorer",
                "url": "https://explorer.metall2.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 1750,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Metal L2",
        "domainId": 1000001750,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": false,
        "name": "metal",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.metall2.com"
            }
        ],
        "technicalStack": "opstack"
    },
    "metertestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.meter.io",
                "family": "other",
                "name": "Meter Testnet Explorer",
                "url": "https://scan.meter.io/"
            }
        ],
        "chainId": 83,
        "deployers": {
            "name": "JaunePomme",
            "url": "https://github.com/JaunePomme"
        },
        "displayName": "Meter testnet",
        "domainId": 83,
        "isTestnet": true,
        "name": "metertestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpctest.meter.io"
            }
        ]
    },
    "metis": {
        "blockExplorers": [
            {
                "apiUrl": "https://andromeda-explorer.metis.io/api/eth-rpc",
                "family": "blockscout",
                "name": "Metis Andromeda Explorer",
                "url": "https://andromeda-explorer.metis.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 5
        },
        "chainId": 1088,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Metis Andromeda",
        "domainId": 1088,
        "gasCurrencyCoinGeckoId": "metis-token",
        "index": {
            "from": 17966274
        },
        "name": "metis",
        "nativeToken": {
            "decimals": 18,
            "name": "Metis",
            "symbol": "METIS"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://andromeda.metis.io/?owner=1088"
            }
        ],
        "technicalStack": "opstack"
    },
    "mevmdevnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.devnet.imola.movementlabs.xyz/api",
                "family": "other",
                "name": "Movement EVM Testnet Explorer",
                "url": "https://explorer.devnet.imola.movementlabs.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 30732,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Movement EVM Devnet",
        "domainId": 30732,
        "gasCurrencyCoinGeckoId": "movement",
        "isTestnet": true,
        "name": "mevmdevnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Movement",
            "symbol": "MOVE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mevm.devnet.imola.movementlabs.xyz"
            }
        ]
    },
    "mint": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.mintchain.io/api/eth-rpc",
                "family": "blockscout",
                "name": "Mint Explorer",
                "url": "https://explorer.mintchain.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 185,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Mint",
        "domainId": 185,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction-mint.safe.optimism.io",
        "name": "mint",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mintchain.io"
            }
        ],
        "technicalStack": "opstack"
    },
    "mintsepoliatest": {
        "blockExplorers": [
            {
                "apiUrl": "https://sepolia-testnet-explorer.mintchain.io/api/v2/",
                "family": "blockscout",
                "name": "Mint Sepolia Testnet explorer",
                "url": "https://sepolia-testnet-explorer.mintchain.io"
            }
        ],
        "chainId": 1687,
        "displayName": "Mint Sepolia Testnet",
        "domainId": 1687,
        "isTestnet": true,
        "name": "mintsepoliatest",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia-testnet-rpc.mintchain.io"
            }
        ]
    },
    "mode": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.mode.network/api",
                "family": "blockscout",
                "name": "Mode Explorer",
                "url": "https://explorer.mode.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 34443,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Mode",
        "domainId": 34443,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction-mode.safe.optimism.io",
        "name": "mode",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.mode.network"
            },
            {
                "http": "https://mode.drpc.org"
            }
        ],
        "technicalStack": "opstack"
    },
    "modetestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.modescan.io/api",
                "family": "etherscan",
                "name": "Mode Testnet Explorer",
                "url": "https://testnet.modescan.io/"
            }
        ],
        "chainId": 919,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Mode Testnet",
        "domainId": 919,
        "isTestnet": true,
        "name": "modetestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.mode.network"
            }
        ]
    },
    "molten": {
        "blockExplorers": [
            {
                "apiUrl": "https://molten.calderaexplorer.xyz/api",
                "family": "blockscout",
                "name": "Caldera Molten Explorer",
                "url": "https://molten.calderaexplorer.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 0
        },
        "chainId": 360,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Molten",
        "domainId": 360,
        "gasCurrencyCoinGeckoId": "molten-2",
        "index": {
            "from": 4707345
        },
        "name": "molten",
        "nativeToken": {
            "decimals": 18,
            "name": "Molten",
            "symbol": "MOLTEN"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://molten.calderachain.xyz/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "moonbase": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-moonbase.moonscan.io/api",
                "family": "etherscan",
                "name": "Moonbase Alpha Testnet Explorer",
                "url": "https://moonbase.moonscan.io"
            }
        ],
        "chainId": 1287,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Moonbase Testnet",
        "domainId": 1287,
        "isTestnet": true,
        "name": "moonbase",
        "nativeToken": {
            "decimals": 18,
            "name": "Dev",
            "symbol": "DEV"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://moonbase-alpha.public.blastapi.io"
            },
            {
                "http": "https://moonbase.unitedbloc.com"
            },
            {
                "http": "https://rpc.testnet.moonbeam.network"
            },
            {
                "http": "https://rpc.testnet.moonbeam.network"
            }
        ]
    },
    "moonbeam": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-moonbeam.moonscan.io/api",
                "family": "etherscan",
                "name": "MoonScan",
                "url": "https://moonscan.io"
            }
        ],
        "blocks": {
            "confirmations": 2,
            "estimateBlockTime": 12,
            "reorgPeriod": "finalized"
        },
        "chainId": 1284,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Moonbeam",
        "domainId": 1284,
        "gasCurrencyCoinGeckoId": "moonbeam",
        "gnosisSafeTransactionServiceUrl": "https://transaction.multisig.moonbeam.network",
        "name": "moonbeam",
        "nativeToken": {
            "decimals": 18,
            "name": "Moonbeam",
            "symbol": "GLMR"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.api.moonbeam.network"
            }
        ],
        "technicalStack": "polkadotsubstrate"
    },
    "morph": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-api.morphl2.io/api",
                "family": "blockscout",
                "name": "Morph Explorer",
                "url": "https://explorer.morphl2.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 4,
            "reorgPeriod": 5
        },
        "chainId": 2818,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Morph",
        "domainId": 2818,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "morph",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.morphl2.io"
            }
        ],
        "technicalStack": "other"
    },
    "nautilus": {
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 22222,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Nautilus",
        "domainId": 22222,
        "gasCurrencyCoinGeckoId": "zebec-protocol",
        "name": "nautilus",
        "nativeToken": {
            "decimals": 18,
            "name": "Zebec",
            "symbol": "ZBC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.nautilus.nautchain.xyz"
            }
        ],
        "technicalStack": "other"
    },
    "neoxt4": {
        "blockExplorers": [
            {
                "apiUrl": "https://xt4scan.ngd.network/api",
                "family": "blockscout",
                "name": "xt4scan",
                "url": "https://xt4scan.ngd.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 15,
            "reorgPeriod": 12
        },
        "chainId": 12227332,
        "deployer": {
            "name": "Neo Global Development",
            "url": "https://x.neo.org"
        },
        "displayName": "NeoX T4",
        "domainId": 12227332,
        "isTestnet": true,
        "name": "neoxt4",
        "nativeToken": {
            "decimals": 18,
            "name": "GAS",
            "symbol": "GAS"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://neoxt4seed1.ngd.network"
            },
            {
                "http": "https://testnet.rpc.banelabs.org"
            }
        ],
        "transactionOverrides": {
            "maxFeePerGas": 40000000000,
            "maxPriorityFeePerGas": 20000000000
        }
    },
    "neutron": {
        "bech32Prefix": "neutron",
        "blockExplorers": [
            {
                "apiUrl": "https://apis.mintscan.io/v1/neutron",
                "family": "other",
                "name": "Mintscan",
                "url": "https://www.mintscan.io/neutron"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 1
        },
        "canonicalAsset": "untrn",
        "chainId": "neutron-1",
        "contractAddressBytes": 32,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Neutron",
        "domainId": 1853125230,
        "gasCurrencyCoinGeckoId": "neutron-3",
        "gasPrice": {
            "amount": "0.0053",
            "denom": "untrn"
        },
        "grpcUrls": [
            {
                "http": "http://grpc-kralum.neutron-1.neutron.org:80"
            }
        ],
        "index": {
            "chunk": 5,
            "from": 4000000
        },
        "name": "neutron",
        "nativeToken": {
            "decimals": 6,
            "denom": "untrn",
            "name": "Neutron",
            "symbol": "NTRN"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://rest-lb.neutron.org"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://rpc-arch.mainnet.neutron.tm.p2p.org"
            },
            {
                "http": "https://rpc-kralum.neutron-1.neutron.org"
            }
        ],
        "slip44": 118,
        "technicalStack": "other",
        "transactionOverrides": {
            "gasPrice": "0.0075"
        }
    },
    "odysseytestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://odyssey-explorer.ithaca.xyz/api",
                "family": "blockscout",
                "name": "Odyssey Explorer",
                "url": "https://odyssey-explorer.ithaca.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 911867,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Odyssey Testnet",
        "domainId": 911867,
        "isTestnet": true,
        "name": "odysseytestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://odyssey.ithaca.xyz"
            }
        ]
    },
    "oortmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://mainnet-scan.oortech.com/api",
                "family": "other",
                "name": "Oort Olympus Explorer",
                "url": "https://mainnet-scan.oortech.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 970,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Oort",
        "domainId": 970,
        "gasCurrencyCoinGeckoId": "oort",
        "name": "oortmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Oort",
            "symbol": "OORT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet-rpc.oortech.com"
            }
        ],
        "technicalStack": "other"
    },
    "opbnb": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-opbnb.bscscan.com/api",
                "family": "etherscan",
                "name": "opBNB Scan",
                "url": "https://opbnb.bscscan.com"
            }
        ],
        "chainId": 204,
        "deployer": {
            "name": "JunayedMh",
            "url": "https://github.com/JunayedMh"
        },
        "displayName": "opBNB",
        "domainId": 204,
        "isTestnet": false,
        "name": "opbnb",
        "nativeToken": {
            "decimals": 18,
            "name": "BNB",
            "symbol": "BNB"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://opbnb-rpc.publicnode.com"
            }
        ]
    },
    "opbnbtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://opbnb-testnet.bscscan.com/api",
                "family": "etherscan",
                "name": "opbnbscan",
                "url": "https://opbnb-testnet.bscscan.com/"
            }
        ],
        "chainId": 5611,
        "deployer": {
            "name": "JunayedMh",
            "url": "https://github.com/JunayedMh"
        },
        "displayName": "Op Bnb Testnet",
        "domainId": 5611,
        "isTestnet": true,
        "name": "opbnbtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Binance",
            "symbol": "tBNB"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://opbnb-testnet-rpc.publicnode.com"
            },
            {
                "http": "https://opbnb-testnet-rpc.bnbchain.org"
            }
        ]
    },
    "optimism": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-optimistic.etherscan.io/api",
                "family": "etherscan",
                "name": "Etherscan",
                "url": "https://optimistic.etherscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 10
        },
        "chainId": 10,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Optimism",
        "domainId": 10,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-optimism.safe.global/",
        "name": "optimism",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.optimism.io"
            }
        ],
        "technicalStack": "opstack"
    },
    "optimismsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia-optimistic.etherscan.io/api",
                "family": "etherscan",
                "name": "OP Sepolia Explorer",
                "url": "https://sepolia-optimistic.etherscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 0
        },
        "chainId": 11155420,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Optimism Sepolia",
        "domainId": 11155420,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "optimismsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.optimism.io"
            }
        ]
    },
    "orderly": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.orderly.network/api",
                "family": "blockscout",
                "name": "Orderly L2 Explorer",
                "url": "https://explorer.orderly.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 291,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Orderly L2",
        "domainId": 291,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "orderly",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.orderly.network"
            },
            {
                "http": "https://l2-orderly-mainnet-0.t.conduit.xyz"
            }
        ],
        "technicalStack": "opstack"
    },
    "osmosis": {
        "bech32Prefix": "osmo",
        "blockExplorers": [
            {
                "apiUrl": "https://apis.mintscan.io/v1/osmosis",
                "family": "other",
                "name": "Mintscan",
                "url": "https://www.mintscan.io/osmosis"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 1
        },
        "canonicalAsset": "uosmo",
        "chainId": "osmosis-1",
        "contractAddressBytes": 32,
        "deployer": {
            "name": "Mitosis",
            "url": "https://mitosis.org"
        },
        "displayName": "Osmosis",
        "domainId": 875,
        "gasCurrencyCoinGeckoId": "osmosis",
        "gasPrice": {
            "amount": "0.025",
            "denom": "uosmo"
        },
        "grpcUrls": [
            {
                "http": "https://osmosis-grpc.publicnode.com:443"
            }
        ],
        "index": {
            "chunk": 10,
            "from": 14389169
        },
        "isTestnet": false,
        "name": "osmosis",
        "nativeToken": {
            "decimals": 6,
            "denom": "uosmo",
            "name": "Osmosis",
            "symbol": "OSMO"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://osmosis-rest.publicnode.com"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://osmosis-rpc.publicnode.com"
            }
        ],
        "slip44": 118,
        "technicalStack": "other",
        "transactionOverrides": {
            "gasPrice": "0.025"
        }
    },
    "piccadilly": {
        "blockExplorers": [
            {
                "apiUrl": "https://piccadilly.autonity.org/api",
                "family": "blockscout",
                "name": "BlockScout",
                "url": "https://piccadilly.autonity.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1
        },
        "chainId": 65100003,
        "deployer": {
            "name": "M8B",
            "url": "https://m8b.dev"
        },
        "displayName": "Autonity Piccadilly",
        "displayNameShort": "Piccadilly",
        "domainId": 65100003,
        "isTestnet": true,
        "name": "piccadilly",
        "nativeToken": {
            "decimals": 18,
            "name": "Auton",
            "symbol": "ATN"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc1.piccadilly.autonity.org"
            }
        ]
    },
    "plumetestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://plume-testnet.explorer.caldera.xyz/api",
                "family": "blockscout",
                "name": "Plume Testnet Explorer",
                "url": "https://plume-testnet.explorer.caldera.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 0
        },
        "chainId": 161221135,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Plume Testnet",
        "domainId": 161221135,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 5284139
        },
        "isTestnet": true,
        "name": "plumetestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://plume-testnet.rpc.caldera.xyz/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "polygon": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.polygonscan.com/api",
                "family": "etherscan",
                "name": "PolygonScan",
                "url": "https://polygonscan.com"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 2,
            "reorgPeriod": "finalized"
        },
        "chainId": 137,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Polygon",
        "domainId": 137,
        "gasCurrencyCoinGeckoId": "polygon-ecosystem-token",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-polygon.safe.global/",
        "name": "polygon",
        "nativeToken": {
            "decimals": 18,
            "name": "Polygon Ecosystem Token",
            "symbol": "POL"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://polygon-bor.publicnode.com"
            },
            {
                "http": "https://polygon-rpc.com"
            },
            {
                "http": "https://rpc.ankr.com/polygon"
            }
        ],
        "technicalStack": "other"
    },
    "polygonamoy": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-amoy.polygonscan.com/api",
                "family": "etherscan",
                "name": "Polygon Amoy Explorer",
                "url": "https://amoy.polygonscan.com"
            }
        ],
        "blocks": {
            "confirmations": 5,
            "estimateBlockTime": 2,
            "reorgPeriod": 10
        },
        "chainId": 80002,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Polygon Amoy",
        "domainId": 80002,
        "gasCurrencyCoinGeckoId": "polygon-ecosystem-token",
        "isTestnet": true,
        "name": "polygonamoy",
        "nativeToken": {
            "decimals": 18,
            "name": "Polygon Ecosystem Token",
            "symbol": "POL"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-amoy.polygon.technology"
            },
            {
                "http": "https://polygon-amoy-bor-rpc.publicnode.com"
            },
            {
                "http": "https://polygon-amoy.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://rpc.ankr.com/polygon_amoy"
            }
        ]
    },
    "polygonzkevm": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-zkevm.polygonscan.com/api",
                "family": "etherscan",
                "name": "PolygonScan",
                "url": "https://zkevm.polygonscan.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 10,
            "reorgPeriod": 5
        },
        "chainId": 1101,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Polygon zkEVM",
        "displayNameShort": "zkEVM",
        "domainId": 1101,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-zkevm.safe.global/",
        "name": "polygonzkevm",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://zkevm-rpc.com"
            },
            {
                "http": "https://rpc.ankr.com/polygon_zkevm"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "polynomialfi": {
        "blockExplorers": [
            {
                "apiUrl": "https://polynomialscan.io/api",
                "family": "routescan",
                "name": "Polynomial Explorer",
                "url": "https://polynomialscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 8008,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Polynomial",
        "domainId": 1000008008,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "polynomialfi",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.polynomial.fi"
            }
        ],
        "technicalStack": "opstack"
    },
    "prom": {
        "blockExplorers": [
            {
                "apiUrl": "https://prom-blockscout.eu-north-2.gateway.fm/api/eth-rpc",
                "family": "blockscout",
                "name": "Prom Explorer",
                "url": "https://prom-blockscout.eu-north-2.gateway.fm"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 5
        },
        "chainId": 227,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Prom",
        "domainId": 227,
        "gasCurrencyCoinGeckoId": "prometeus",
        "name": "prom",
        "nativeToken": {
            "decimals": 18,
            "name": "Prom",
            "symbol": "PROM"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://prom-rpc.eu-north-2.gateway.fm"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "proofofplay": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.apex.proofofplay.com/api/eth-rpc",
                "family": "blockscout",
                "name": "Proof of Play Apex Explorer",
                "url": "https://explorer.apex.proofofplay.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 5
        },
        "chainId": 70700,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Proof of Play Apex",
        "domainId": 70700,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 32018468
        },
        "name": "proofofplay",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.apex.proofofplay.com"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "pulsechain": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.scan.pulsechain.com/api",
                "family": "blockscout",
                "name": "Pulsechain Explorer",
                "url": "https://oldscan.gopulse.com/#/"
            },
            {
                "apiUrl": "https://api.scan.pulsechain.com/api",
                "family": "other",
                "name": "Otterscan",
                "url": "https://otter.pulsechain.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 10,
            "reorgPeriod": 0
        },
        "chainId": 369,
        "deployer": {
            "name": "ganadhish-RL",
            "url": "https://github.com/ganadhish-RL"
        },
        "displayName": "PulseChain",
        "domainId": 369,
        "gasCurrencyCoinGeckoId": "pulsechain",
        "isTestnet": false,
        "name": "pulsechain",
        "nativeToken": {
            "decimals": 18,
            "name": "PulseChain",
            "symbol": "PLS"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.pulsechain.com"
            },
            {
                "http": "https://pulsechain-rpc.publicnode.com"
            }
        ],
        "transactionOverrides": {
            "maxFeePerGas": 800000000000000,
            "maxPriorityFeePerGas": 2500000000
        }
    },
    "rarichain": {
        "blockExplorers": [
            {
                "apiUrl": "https://mainnet.explorer.rarichain.org/api",
                "family": "blockscout",
                "name": "Rari Mainnet Explorer",
                "url": "https://mainnet.explorer.rarichain.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 0
        },
        "chainId": 1380012617,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "RARI Chain",
        "domainId": 1000012617,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 688784
        },
        "name": "rarichain",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.rpc.rarichain.org/http"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "real": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.re.al/api/eth-rpc",
                "family": "blockscout",
                "name": "re.al Explorer",
                "url": "https://explorer.re.al"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 0
        },
        "chainId": 111188,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "re.al",
        "domainId": 111188,
        "gasCurrencyCoinGeckoId": "real-ether",
        "index": {
            "from": 363159
        },
        "name": "real",
        "nativeToken": {
            "decimals": 18,
            "name": "Real Ether",
            "symbol": "reETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://real.drpc.org"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "redstone": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.redstone.xyz/api",
                "family": "blockscout",
                "name": "Redstone Explorer",
                "url": "https://explorer.redstone.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 690,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Redstone",
        "domainId": 690,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction-redstone.safe.optimism.io",
        "name": "redstone",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.redstonechain.com"
            }
        ],
        "technicalStack": "opstack"
    },
    "ronin": {
        "blockExplorers": [
            {
                "apiUrl": "https://app.roninchain.com/api",
                "family": "other",
                "name": "Ronin Explorer",
                "url": "https://app.roninchain.com"
            }
        ],
        "blocks": {
            "confirmations": 15,
            "estimateBlockTime": 3,
            "reorgPeriod": 0
        },
        "chainId": 2020,
        "displayName": "Ronin",
        "domainId": 2020,
        "gasCurrencyCoinGeckoId": "ronin",
        "name": "ronin",
        "nativeToken": {
            "decimals": 18,
            "name": "Ronin",
            "symbol": "RON"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://api.roninchain.com/rpc"
            }
        ]
    },
    "rootstockmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://rootstock.blockscout.com/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://rootstock.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 4
        },
        "chainId": 30,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Rootstock",
        "domainId": 1000000030,
        "gasCurrencyCoinGeckoId": "rootstock",
        "name": "rootstockmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Rootstock Smart Bitcoin",
            "symbol": "RBTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mainnet.rootstock.io/kXhXHf6TnnfW1POvr4UT0YUvujmuju-M"
            },
            {
                "http": "https://public-node.rsk.co"
            },
            {
                "http": "https://mycrypto.rsk.co"
            }
        ],
        "technicalStack": "other"
    },
    "rootstocktestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://rootstock-testnet.blockscout.com/api",
                "family": "blockscout",
                "name": "Blockscout",
                "url": "https://rootstock-testnet.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 30,
            "reorgPeriod": 4
        },
        "chainId": 31,
        "deployer": {
            "name": "Rootstock",
            "url": "https://rootstock.io"
        },
        "displayName": "Rootstock Testnet",
        "domainId": 31,
        "isTestnet": true,
        "name": "rootstocktestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Testnet Rootstock Smart Bitcoin",
            "symbol": "tRBTC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.rootstock.io/YZIZHxGCQAryubOWH7LjdtjNkSDb5J-T"
            }
        ]
    },
    "saakuru": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.saakuru.network/api",
                "family": "blockscout",
                "name": "Saakuru Explorer",
                "url": "https://explorer.saakuru.network"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 7225878,
        "displayName": "Saakuru",
        "domainId": 7225878,
        "gasCurrencyCoinGeckoId": "saakuru-labs",
        "name": "saakuru",
        "nativeToken": {
            "decimals": 18,
            "name": "Saakuru Token",
            "symbol": "SKR"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.saakuru.network"
            }
        ]
    },
    "sanko": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.sanko.xyz/api/eth-rpc",
                "family": "blockscout",
                "name": "Sanko Explorer",
                "url": "https://explorer.sanko.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 15,
            "reorgPeriod": 1
        },
        "chainId": 1996,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Sanko",
        "domainId": 1996,
        "gasCurrencyCoinGeckoId": "dream-machine-token",
        "index": {
            "from": 937117
        },
        "name": "sanko",
        "nativeToken": {
            "decimals": 18,
            "name": "Dream Machine Token",
            "symbol": "DMT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.sanko.xyz"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "scroll": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.scrollscan.com/api",
                "family": "etherscan",
                "name": "Scroll Explorer",
                "url": "https://scrollscan.com/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 17
        },
        "chainId": 534352,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Scroll",
        "domainId": 534352,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-scroll.safe.global",
        "name": "scroll",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://scroll.blockpi.network/v1/rpc/public"
            }
        ],
        "technicalStack": "other"
    },
    "scrollsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.scrollscan.com/api",
                "family": "etherscan",
                "name": "Scroll Explorer",
                "url": "https://sepolia.scrollscan.dev/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 1
        },
        "chainId": 534351,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Scroll Sepolia",
        "domainId": 534351,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "scrollsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia-rpc.scroll.io"
            },
            {
                "http": "https://rpc.ankr.com/scroll_sepolia_testnet"
            },
            {
                "http": "https://scroll-sepolia.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://scroll-sepolia.chainstacklabs.com"
            },
            {
                "http": "https://scroll-public.scroll-testnet.quiknode.pro"
            }
        ]
    },
    "sei": {
        "blockExplorers": [
            {
                "apiUrl": "https://seitrace.com/pacific-1/api",
                "family": "etherscan",
                "name": "Seitrace",
                "url": "https://seitrace.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 1329,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Sei",
        "domainId": 1329,
        "gasCurrencyCoinGeckoId": "sei-network",
        "gnosisSafeTransactionServiceUrl": "https://transaction.sei-safe.protofire.io",
        "name": "sei",
        "nativeToken": {
            "decimals": 18,
            "name": "Sei",
            "symbol": "SEI"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://evm-rpc.sei-apis.com"
            }
        ],
        "technicalStack": "other"
    },
    "sepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-sepolia.etherscan.io/api",
                "family": "etherscan",
                "name": "Etherscan",
                "url": "https://sepolia.etherscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 13,
            "reorgPeriod": 2
        },
        "chainId": 11155111,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Sepolia",
        "domainId": 11155111,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://safe-transaction-sepolia.safe.global",
        "isTestnet": true,
        "name": "sepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://ethereum-sepolia.publicnode.com"
            },
            {
                "http": "https://ethereum-sepolia.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://rpc.sepolia.org"
            }
        ]
    },
    "shibarium": {
        "blockExplorers": [
            {
                "apiUrl": "https://shibariumscan.io/api",
                "family": "blockscout",
                "name": "Shibarium Explorer",
                "url": "https://shibariumscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": "finalized"
        },
        "chainId": 109,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Shibarium",
        "domainId": 109,
        "gasCurrencyCoinGeckoId": "bone-shibaswap",
        "name": "shibarium",
        "nativeToken": {
            "decimals": 18,
            "name": "Bone ShibaSwap",
            "symbol": "BONE"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://www.shibrpc.com"
            },
            {
                "http": "https://rpc.shibrpc.com"
            }
        ],
        "technicalStack": "other"
    },
    "sketchpad": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.sketchpad-1.forma.art/api",
                "family": "blockscout",
                "name": "Forma Sketchpad Explorer",
                "url": "https://explorer.sketchpad-1.forma.art"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 0
        },
        "chainId": 984123,
        "deployer": {
            "name": "Codecrafting Labs",
            "url": "https://cclabs.tech"
        },
        "displayName": "Forma Sketchpad",
        "displayNameShort": "Sketchpad",
        "domainId": 984123,
        "gasCurrencyCoinGeckoId": "celestia",
        "isTestnet": true,
        "name": "sketchpad",
        "nativeToken": {
            "decimals": 18,
            "name": "Celestia",
            "symbol": "TIA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.sketchpad-1.forma.art"
            }
        ]
    },
    "smartbch": {
        "blockExplorers": [
            {
                "apiUrl": "https://smartscout.cash/api",
                "family": "blockscout",
                "name": "SmartBCH Explorer",
                "url": "https://smartscout.cash"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 15
        },
        "chainId": 10000,
        "deployer": {
            "name": "Goblins Cash",
            "url": "https://goblins.cash"
        },
        "displayName": "Smartbch",
        "domainId": 10000,
        "isTestnet": false,
        "name": "smartbch",
        "nativeToken": {
            "decimals": 18,
            "name": "BCH",
            "symbol": "BCH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://smartbch.greyh.at"
            },
            {
                "http": "https://rpc.smartbch.org"
            }
        ]
    },
    "snaxchain": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.snaxchain.io/api",
                "family": "blockscout",
                "name": "Snaxchain Mainnet Explorer",
                "url": "https://explorer.snaxchain.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 2192,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "SnaxChain",
        "domainId": 2192,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "snaxchain",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.snaxchain.io"
            }
        ],
        "technicalStack": "opstack"
    },
    "solanadevnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.solana.com?cluster=devnet",
                "family": "other",
                "name": "Solana Explorer",
                "url": "https://explorer.solana.com?cluster=devnet"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.4,
            "reorgPeriod": 0
        },
        "chainId": 1399811151,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Solana Devnet",
        "displayNameShort": "Sol Devnet",
        "domainId": 1399811151,
        "isTestnet": true,
        "name": "solanadevnet",
        "nativeToken": {
            "decimals": 9,
            "name": "Solana",
            "symbol": "SOL"
        },
        "protocol": "sealevel",
        "rpcUrls": [
            {
                "http": "https://api.devnet.solana.com"
            }
        ]
    },
    "solanamainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://solscan.io",
                "family": "other",
                "name": "Solana Explorer",
                "url": "https://solscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.4,
            "reorgPeriod": 0
        },
        "chainId": 1399811149,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Solana",
        "domainId": 1399811149,
        "gasCurrencyCoinGeckoId": "solana",
        "name": "solanamainnet",
        "nativeToken": {
            "decimals": 9,
            "name": "Solana",
            "symbol": "SOL"
        },
        "protocol": "sealevel",
        "rpcUrls": [
            {
                "http": "https://api.mainnet-beta.solana.com"
            }
        ],
        "technicalStack": "other"
    },
    "solanatestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.solana.com?cluster=testnet",
                "family": "other",
                "name": "Solana Explorer",
                "url": "https://explorer.solana.com?cluster=testnet"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 0.4,
            "reorgPeriod": 0
        },
        "chainId": 1399811150,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Solana Testnet",
        "displayNameShort": "Sol Testnet",
        "domainId": 1399811150,
        "gasCurrencyCoinGeckoId": "solana",
        "isTestnet": true,
        "name": "solanatestnet",
        "nativeToken": {
            "decimals": 9,
            "name": "Solana",
            "symbol": "SOL"
        },
        "protocol": "sealevel",
        "rpcUrls": [
            {
                "http": "https://api.testnet.solana.com"
            }
        ]
    },
    "soneiumtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer-testnet.soneium.org/api",
                "family": "blockscout",
                "name": "Soneium Minato Testnet Explorer",
                "url": "https://explorer-testnet.soneium.org"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 1
        },
        "chainId": 1946,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Soneium Minato Testnet",
        "domainId": 1946,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "soneiumtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.minato.soneium.org"
            }
        ]
    },
    "sonictestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.soniclabs.com/api",
                "family": "routescan",
                "name": "Sonic Testnet Explorer",
                "url": "https://testnet.soniclabs.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 64165,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Sonic Testnet",
        "domainId": 64165,
        "isTestnet": true,
        "name": "sonictestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Sonic",
            "symbol": "S"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.soniclabs.com"
            }
        ]
    },
    "sophonsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-explorer-verify.testnet.sophon.xyz/contract_verification",
                "family": "etherscan",
                "name": "Sophon Testnet Explorer",
                "url": "https://explorer.testnet.sophon.xyz"
            }
        ],
        "chainId": 531050104,
        "deployer": {
            "name": "txFusion",
            "url": "https://txfusion.io"
        },
        "displayName": "Sophon Sepolia",
        "domainId": 531050104,
        "isTestnet": true,
        "name": "sophonsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "sophon",
            "symbol": "SOPH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.testnet.sophon.xyz"
            }
        ],
        "technicalStack": "zksync"
    },
    "storyodysseytestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://odyssey-testnet-explorer.storyscan.xyz/api",
                "family": "blockscout",
                "name": "StoryScan",
                "url": "https://odyssey-testnet-explorer.storyscan.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 3,
            "reorgPeriod": 0
        },
        "chainId": 1516,
        "deployer": {
            "name": "hoanm",
            "url": "https://github.com/hoanm"
        },
        "displayName": "Story Odyssey Testnet",
        "domainId": 1516,
        "isTestnet": true,
        "name": "storyodysseytestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "IP",
            "symbol": "IP"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://odyssey.storyrpc.io"
            }
        ]
    },
    "storytestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.storyscan.xyz/api",
                "family": "blockscout",
                "name": "storyexplorer",
                "url": "https://testnet.storyscan.xyz"
            }
        ],
        "chainId": 1513,
        "deployer": {
            "name": "atuser14",
            "url": "https://github.com/atuser14"
        },
        "displayName": "Story Testnet",
        "domainId": 1513,
        "isTestnet": true,
        "name": "storytestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "IP",
            "symbol": "IP"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://story-testnet-evm.itrocket.net"
            },
            {
                "http": "https://story-rpc.oneiricts.com:8445"
            },
            {
                "http": "https://testnet.storyrpc.io"
            }
        ],
        "transactionOverrides": {
            "gasPrice": 16000000000
        }
    },
    "stride": {
        "bech32Prefix": "stride",
        "blockExplorers": [
            {
                "apiUrl": "https://apis.mintscan.io/v1/stride",
                "family": "other",
                "name": "Mintscan",
                "url": "https://www.mintscan.io/stride"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 1
        },
        "canonicalAsset": "ustrd",
        "chainId": "stride-1",
        "contractAddressBytes": 32,
        "deployer": {
            "name": "Stride Labs",
            "url": "https://www.stride.zone"
        },
        "displayName": "Stride",
        "domainId": 745,
        "gasCurrencyCoinGeckoId": "stride",
        "gasPrice": {
            "amount": "0.025",
            "denom": "ustrd"
        },
        "grpcUrls": [
            {
                "http": "https://stride-grpc.publicnode.com:443"
            }
        ],
        "index": {
            "chunk": 5,
            "from": 9152000
        },
        "name": "stride",
        "nativeToken": {
            "decimals": 6,
            "denom": "ustrd",
            "name": "Stride",
            "symbol": "STRD"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://stride-api.polkachu.com"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://stride-rpc.polkachu.com"
            }
        ],
        "slip44": 118,
        "transactionOverrides": {
            "gasPrice": "0.0025"
        }
    },
    "stridetestnet": {
        "bech32Prefix": "stride",
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.ping.pub/stride",
                "family": "other",
                "name": "Mintscan",
                "url": "https://testnet.ping.pub/stride"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 5,
            "reorgPeriod": 1
        },
        "chainId": "stride-internal-1",
        "deployer": {
            "name": "Stride Labs",
            "url": "https://www.stride.zone"
        },
        "displayName": "Stride Testnet",
        "domainId": 1651,
        "gasCurrencyCoinGeckoId": "stride",
        "grpcUrls": [
            {
                "http": "stride-testnet-grpc.polkachu.com:12290"
            }
        ],
        "isTestnet": true,
        "name": "stridetestnet",
        "nativeToken": {
            "decimals": 6,
            "denom": "ustrd",
            "name": "Stride",
            "symbol": "STRD"
        },
        "protocol": "cosmos",
        "restUrls": [
            {
                "http": "https://stride-testnet-api.polkachu.com"
            }
        ],
        "rpcUrls": [
            {
                "http": "https://stride-testnet-rpc.polkachu.com"
            }
        ],
        "slip44": 118,
        "transactionOverrides": {
            "gasPrice": "0.0025"
        }
    },
    "suavetoliman": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.toliman.suave.flashbots.net/api",
                "family": "blockscout",
                "name": "SUAVE Toliman Testnet Explorer",
                "url": "https://explorer.toliman.suave.flashbots.net"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 4,
            "reorgPeriod": 1
        },
        "chainId": 33626250,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "SUAVE Toliman Testnet",
        "domainId": 33626250,
        "gasCurrencyCoinGeckoId": "ethereum",
        "isTestnet": true,
        "name": "suavetoliman",
        "nativeToken": {
            "decimals": 18,
            "name": "TEEth",
            "symbol": "TEEth"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.toliman.suave.flashbots.net"
            }
        ]
    },
    "superpositionmainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.superposition.so/api",
                "family": "blockscout",
                "name": "Superposition Explorer",
                "url": "https://explorer.superposition.so/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 60,
            "reorgPeriod": 0
        },
        "chainId": 55244,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Superposition",
        "domainId": 1000055244,
        "gasCurrencyCoinGeckoId": "ethereum",
        "index": {
            "from": 2743
        },
        "name": "superpositionmainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ethereum",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.superposition.so"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "superpositiontestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet-explorer.superposition.so/api",
                "family": "blockscout",
                "name": "Superposition Testnet Explorer",
                "url": "https://testnet-explorer.superposition.so"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 98985,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Superposition Testnet",
        "domainId": 98985,
        "gasCurrencyCoinGeckoId": "superposition",
        "index": {
            "from": 3111622
        },
        "isTestnet": true,
        "name": "superpositiontestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Superposition",
            "symbol": "SPN"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://testnet-rpc.superposition.so"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "superseedtestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://sepolia-explorer.superseed.xyz/api",
                "family": "blockscout",
                "name": "Superseed Sepolia Explorer",
                "url": "https://sepolia-explorer.superseed.xyz"
            }
        ],
        "chainId": 53302,
        "deployer": {
            "name": "Fazleiw",
            "url": "https://github.com/Fazleiw"
        },
        "displayName": "Superseed Testnet",
        "domainId": 53302,
        "isTestnet": true,
        "name": "superseedtestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.superseed.xyz"
            }
        ]
    },
    "taiko": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.taikoscan.io/api",
                "family": "etherscan",
                "name": "Taikoscan",
                "url": "https://taikoscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 12,
            "reorgPeriod": 5
        },
        "chainId": 167000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Taiko",
        "domainId": 167000,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.taiko.xyz",
        "name": "taiko",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.mainnet.taiko.xyz"
            }
        ],
        "technicalStack": "other"
    },
    "taikohekla": {
        "blockExplorers": [
            {
                "apiUrl": "https://api.routescan.io/v2/network/testnet/evm/167009/etherscan/api",
                "family": "etherscan",
                "name": "Taiko Hekla Explorer",
                "url": "https://hekla.taikoscan.network"
            }
        ],
        "chainId": 167009,
        "deployer": {
            "name": "tmr",
            "url": "https://t.me/netimer"
        },
        "displayName": "Taiko Hekla",
        "domainId": 167009,
        "isTestnet": true,
        "name": "taikohekla",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://taiko-hekla.drpc.org"
            },
            {
                "http": "https://rpc.hekla.taiko.xyz"
            }
        ]
    },
    "tangle": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.tangle.tools/api",
                "family": "blockscout",
                "name": "Tangle EVM Explorer",
                "url": "https://explorer.tangle.tools"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": "finalized"
        },
        "chainId": 5845,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Tangle",
        "domainId": 5845,
        "gasCurrencyCoinGeckoId": "tangle-network",
        "isTestnet": false,
        "name": "tangle",
        "nativeToken": {
            "decimals": 18,
            "name": "Tangle Network Token",
            "symbol": "TNT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.tangle.tools"
            }
        ],
        "technicalStack": "polkadotsubstrate"
    },
    "tangletestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet-explorer.tangle.tools/api",
                "family": "blockscout",
                "name": "Tangle Test Network Explorer",
                "url": "https://testnet-explorer.tangle.tools/"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 0
        },
        "chainId": 3799,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Tangle Testnet",
        "domainId": 3799,
        "isTestnet": true,
        "name": "tangletestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Tangle Network Token",
            "symbol": "tTNT"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://testnet-rpc.tangle.tools"
            }
        ]
    },
    "tenet": {
        "blockExplorers": [
            {
                "apiUrl": "https://tenetscan.io/api",
                "family": "other",
                "name": "Tenet Explorer",
                "url": "https://tenetscan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 4,
            "reorgPeriod": 0
        },
        "chainId": 1559,
        "displayName": "Tenet",
        "domainId": 1559,
        "gasCurrencyCoinGeckoId": "tenet-1b000f7b-59cb-4e06-89ce-d62b32d362b9",
        "name": "tenet",
        "nativeToken": {
            "decimals": 18,
            "name": "Tenet",
            "symbol": "TENET"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.tenet.org"
            },
            {
                "http": "https://tenet-evm.publicnode.com"
            }
        ]
    },
    "treasuretopaz": {
        "blockExplorers": [
            {
                "apiUrl": "https://rpc-explorer-verify.topaz.treasure.lol/contract_verification",
                "family": "etherscan",
                "name": "Treasure Topaz Block Explorer",
                "url": "https://topaz.treasurescan.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 978658,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Treasure Topaz Testnet",
        "displayNameShort": "Treasure Testnet",
        "domainId": 978658,
        "isTestnet": true,
        "name": "treasuretopaz",
        "nativeToken": {
            "decimals": 18,
            "name": "MAGIC",
            "symbol": "MAGIC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.topaz.treasure.lol"
            }
        ],
        "technicalStack": "zksync"
    },
    "u2utestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://testnet.u2uscan.xyz/api",
                "family": "blockscout",
                "name": "u2uscan",
                "url": "https://testnet.u2uscan.xyz"
            }
        ],
        "chainId": 2484,
        "displayName": "U2U Testnet",
        "domainId": 2484,
        "isTestnet": true,
        "name": "u2utestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Union Ultra",
            "symbol": "U2U"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc-nebulas-testnet.uniultra.xyz"
            }
        ]
    },
    "unichaintestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://unichain-sepolia.blockscout.com/api",
                "family": "blockscout",
                "name": "Unichain Sepolia Testnet Explorer",
                "url": "https://unichain-sepolia.blockscout.com"
            }
        ],
        "blocks": {
            "confirmations": 3,
            "estimateBlockTime": 1,
            "reorgPeriod": 1
        },
        "chainId": 1301,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Unichain Testnet",
        "domainId": 1301,
        "isTestnet": true,
        "name": "unichaintestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.unichain.org"
            }
        ]
    },
    "viction": {
        "blockExplorers": [
            {
                "apiUrl": "https://www.vicscan.xyz/api",
                "family": "other",
                "name": "Vicscan",
                "url": "https://www.vicscan.xyz"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 3
        },
        "chainId": 88,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Viction",
        "domainId": 88,
        "gasCurrencyCoinGeckoId": "tomochain",
        "name": "viction",
        "nativeToken": {
            "decimals": 18,
            "name": "Viction",
            "symbol": "VIC"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.tomochain.com"
            },
            {
                "http": "https://viction.blockpi.network/v1/rpc/public"
            }
        ],
        "technicalStack": "other"
    },
    "wanchaintestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://api-xdc.blocksscan.io/api",
                "family": "etherscan",
                "name": "Wanchain Explorer",
                "url": "https://wanexplorer.io"
            }
        ],
        "chainId": 999,
        "deployer": {
            "name": "JaunePomme",
            "url": "https://github.com/JaunePomme"
        },
        "displayName": "Wanchain Testnet",
        "domainId": 999,
        "isTestnet": true,
        "name": "wanchaintestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://gwan-ssl.wandevs.org:46891"
            }
        ]
    },
    "worldchain": {
        "blockExplorers": [
            {
                "apiUrl": "https://worldchain-mainnet-explorer.alchemy.com/api",
                "family": "blockscout",
                "name": "World Chain explorer",
                "url": "https://worldchain-mainnet-explorer.alchemy.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 480,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "World Chain",
        "domainId": 480,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "worldchain",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://worldchain-mainnet.g.alchemy.com/public"
            }
        ],
        "technicalStack": "opstack"
    },
    "xai": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.xai-chain.net/api",
                "family": "blockscout",
                "name": "Xai Explorer",
                "url": "https://explorer.xai-chain.net"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 5
        },
        "chainId": 660279,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Xai",
        "domainId": 660279,
        "gasCurrencyCoinGeckoId": "xai-blockchain",
        "index": {
            "from": 24395308
        },
        "name": "xai",
        "nativeToken": {
            "decimals": 18,
            "name": "XAI Token",
            "symbol": "XAI"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://xai-chain.net/rpc"
            }
        ],
        "technicalStack": "arbitrumnitro"
    },
    "xlayer": {
        "blockExplorers": [
            {
                "apiUrl": "https://www.oklink.com/api",
                "family": "other",
                "name": "X Layer Explorer",
                "url": "https://www.oklink.com/xlayer"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 10,
            "reorgPeriod": 5
        },
        "chainId": 196,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "XLayer",
        "displayNameShort": "XLayer",
        "domainId": 196,
        "gasCurrencyCoinGeckoId": "okb",
        "gnosisSafeTransactionServiceUrl": "https://app.safe.global/welcome?chain=xlayer",
        "name": "xlayer",
        "nativeToken": {
            "decimals": 18,
            "name": "OKB",
            "symbol": "OKB"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://xlayerrpc.okx.com"
            },
            {
                "http": "https://rpc.xlayer.tech"
            }
        ],
        "technicalStack": "polygoncdk"
    },
    "zeronetwork": {
        "blockExplorers": [
            {
                "apiUrl": "https://zero-network.calderaexplorer.xyz/verification/contract_verification",
                "family": "etherscan",
                "name": "Zero Network Explorer",
                "url": "https://zerion-explorer.vercel.app"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 543210,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Zero Network",
        "domainId": 543210,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://prod.zeronet-mainnet.transaction.keypersafe.xyz",
        "name": "zeronetwork",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://zero-network.calderachain.xyz"
            }
        ],
        "technicalStack": "zksync"
    },
    "zetachain": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.zetachain.com",
                "family": "other",
                "name": "ZetaScan",
                "url": "https://explorer.zetachain.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 6,
            "reorgPeriod": 0
        },
        "chainId": 7000,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "ZetaChain",
        "domainId": 7000,
        "gasCurrencyCoinGeckoId": "zetachain",
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.zetachain.com",
        "name": "zetachain",
        "nativeToken": {
            "decimals": 18,
            "name": "ZetaChain",
            "symbol": "ZETA"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://zetachain-evm.blockpi.network/v1/rpc/public"
            },
            {
                "http": "https://zetachain-mainnet.g.allthatnode.com/archive/evm"
            }
        ],
        "technicalStack": "other"
    },
    "zircuit": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.zircuit.com/api/contractVerifyHardhat",
                "family": "etherscan",
                "name": "Zircuit Eplorer",
                "url": "https://explorer.zircuit.com"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 48900,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Zircuit",
        "domainId": 48900,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction.safe.zircuit.com",
        "name": "zircuit",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://zircuit1-mainnet.p2pify.com"
            },
            {
                "http": "https://zircuit1-mainnet.liquify.com"
            },
            {
                "http": "https://zircuit-mainnet.drpc.org"
            }
        ],
        "technicalStack": "opstack"
    },
    "zksync": {
        "blockExplorers": [
            {
                "apiUrl": "https://zksync2-mainnet-explorer.zksync.io/contract_verification",
                "family": "etherscan",
                "name": "zkSync Explorer",
                "url": "https://explorer.zksync.io"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 1,
            "reorgPeriod": 0
        },
        "chainId": 324,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "zkSync",
        "domainId": 324,
        "gasCurrencyCoinGeckoId": "ethereum",
        "name": "zksync",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://mainnet.era.zksync.io"
            }
        ],
        "technicalStack": "zksync"
    },
    "zksyncsepolia": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.sepolia.era.zksync.dev/contract_verification",
                "family": "etherscan",
                "name": "zkSync Sepolia Explorer",
                "url": "https://sepolia.explorer.zksync.io"
            }
        ],
        "chainId": 300,
        "deployer": {
            "name": "txFusion",
            "url": "https://txfusion.io"
        },
        "displayName": "zkSync Sepolia Testnet",
        "domainId": 300,
        "isTestnet": true,
        "name": "zksyncsepolia",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.era.zksync.dev"
            }
        ],
        "technicalStack": "zksync"
    },
    "zoramainnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://explorer.zora.energy/api",
                "family": "blockscout",
                "name": "Zora Explorer",
                "url": "https://explorer.zora.energy"
            }
        ],
        "blocks": {
            "confirmations": 1,
            "estimateBlockTime": 2,
            "reorgPeriod": 5
        },
        "chainId": 7777777,
        "deployer": {
            "name": "Abacus Works",
            "url": "https://www.hyperlane.xyz"
        },
        "displayName": "Zora",
        "domainId": 7777777,
        "gasCurrencyCoinGeckoId": "ethereum",
        "gnosisSafeTransactionServiceUrl": "https://transaction-zora.safe.optimism.io",
        "name": "zoramainnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://rpc.zora.energy"
            }
        ],
        "technicalStack": "opstack"
    },
    "zoratestnet": {
        "blockExplorers": [
            {
                "apiUrl": "https://sepolia.explorer.zora.energy/api",
                "family": "blockscout",
                "name": "Zora Testnet Explorer",
                "url": "https://sepolia.explorer.zora.energy/"
            }
        ],
        "chainId": 999999999,
        "deployer": {
            "name": "guy93354",
            "url": "https://github.com/guy93354"
        },
        "displayName": "Zora Testnet",
        "domainId": 999999999,
        "isTestnet": true,
        "name": "zoratestnet",
        "nativeToken": {
            "decimals": 18,
            "name": "Ether",
            "symbol": "ETH"
        },
        "protocol": "ethereum",
        "rpcUrls": [
            {
                "http": "https://sepolia.rpc.zora.energy"
            }
        ]
    }
};
